import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      welcome: 'Welcome',
      dashboard: 'Dashboard',
      courses: 'Courses',
      myCourses: 'My Courses',
      leaderboard: 'Leaderboard',
      tests: 'Tests',
      assignments: 'Assignments',
      companyQuestions: 'Company Questions',
      jobs: 'Jobs & Internships',
      bookmarks: 'Bookmarks',
      profile: 'Profile',
      chat: 'Chat',
      notifications: 'Notifications',
      settings: 'Settings',
      logout: 'Logout',
      payments: 'Payments',
      paymentManagement: 'Payment Management',
      paymentHistory: 'Payment History',
      makePayment: 'Make Payment',
      paymentSummary: 'Payment Summary',
      offlinePayment: 'Offline Payment',
      onlinePayment: 'Online Payment',
      paymentStatus: 'Payment Status',
      transactionId: 'Transaction ID',
      receipt: 'Receipt',
      balance: 'Balance',
      paidAmount: 'Paid Amount',
      totalCost: 'Total Cost',
      runwayPayment: 'Runway Payment',
      selectRunways: 'Select Runways',
      paymentDetails: 'Payment Details',
      addOfflinePayment: 'Add Offline Payment',
      paymentAnalytics: 'Payment Analytics',
      totalPayments: 'Total Payments',
      successfulPayments: 'Successful Payments',
      pendingPayments: 'Pending Payments',
      collectPayment: 'Collect Payment',
      studentPaymentSupport: 'Student Payment Support',
      paymentCollection: 'Payment Collection',
      batchStudents: 'Batch Students',
      batchRunways: 'Batch Runways',
      selectBatch: 'Select Batch',
      selectStudent: 'Select Student',
      processOfflinePayment: 'Process Offline Payment',
      paymentInitiated: 'Payment Initiated',
      paymentConfirmed: 'Payment Confirmed',
      paymentFailed: 'Payment Failed',
      paymentReceipt: 'Payment Receipt',
      receiptNumber: 'Receipt Number',
      payerName: 'Payer Name',
      paymentMode: 'Payment Mode',
      paymentRemarks: 'Payment Remarks',
      itemsSelected: 'Items Selected',
      currentPaymentSummary: 'Current Payment Summary',
      paymentProgress: 'Payment Progress',
      payNow: 'Pay Now',
      downloadReceipt: 'Download Receipt',
      viewReceipt: 'View Receipt',
      paymentComplete: 'Payment Complete',
      paymentPending: 'Payment Pending',
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      fullName: 'Full Name',
      submit: 'Submit',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      enrollNow: 'Enroll Now',
      startLearning: 'Start Learning',
      continueLearning: 'Continue Learning',
      completed: 'Completed',
      inProgress: 'In Progress',
      notStarted: 'Not Started',
      streak: 'Streak',
      points: 'Points',
      rank: 'Rank',
      totalLessons: 'Total Lessons',
      completedLessons: 'Completed Lessons',
      courseManagement: {
        title: 'Course Management',
        subtitle: 'Online coaching - courses by program (P1,P2,P3), separate curriculum per program, classes Saturday & Sunday',
        editCollege: 'Edit College',
        batches: 'Batches',
        students: 'Students',
        contactAndLocation: 'Contact and location',
        totalStudents: 'Total Students',
        activeBatches: 'Active Batches',
        academicPaths: 'Academic Courses',
        yearStarted: 'Year Started',
        managementPathAndCurriculum: 'Management Course & Curriculum',
        managementPathDescription: 'Manage academic course, entry levels, and curriculum resources',
        addPath: 'Add Course',
        satSunClasses: 'Sat & Sun Classes',
        download: 'Download',
        noManagementPaths: 'No management course created yet.',
        createFirstPath: 'Create First Course',
        noCollegeRegistered: 'No college registered. Add a college to get started.',
        editCollegeDescription: 'Update college details and contact information.',
        collegeName: 'College Name',
        location: 'Location',
        contactDetails: 'Contact Details',
        updateCollege: 'Update College',
        editManagementPath: 'Edit Course',
        createManagementPath: 'Create Course',
        definePathDetails: 'Define the details, program, and duration for this course.',
        pathName: 'Course Name',
        applicableRunway: 'Applicable program',
        selectRunway: 'Select Program',
        batchLabel: 'Batch Label',
        pathDuration: 'Course Duration(in days)',
        description: 'Description',
        updating: 'Updating',
        thumbnail: 'Thumbnail',
        updatePath: 'Update Course',
        createPath: 'Create courses',
        defaultPathDescription: 'Comprehensive curriculum with flexible entry points.',
        deleteConfirmTitle: 'Delete Course?',
        deleteConfirmText: 'This action cannot be undone.',
        loadingPaths: 'Loading Courses...',
        updateFailed: 'Failed to update institute details',
        deletePath: 'Delete Course',
        noCoursesFound: 'No Course Found',
        creating: 'Creating',
        placeholders: {
          collegeName: 'e.g. ABC Engineering College',
          location: 'City or region',
          contactPerson: 'Contact person name',
          email: 'Email',
          phone: 'Phone number',
          pathName: 'e.g. Software Development courses',
          batchLabel: 'e.g. BT1',
          pathDuration: 'e.g. 4',
          description: 'Briefly describe what this courses covers...'
        },
        toast: {
          enterCollegeName: 'Please enter college name',
          collegeUpdated: 'College updated successfully',
          pathNameRunwayRequired: 'Course name and program selection are required',
          pathUpdated: '{{runway}} updated successfully',
          pathCreated: 'New {{runway}} created',
          pathRemoved: 'Course removed',
          downloadingCurriculum: 'Downloading {{runway}} curriculum...',
          pathLoadFailed: 'Failed to load courses',
          pathSaveFailed: 'Failed to save courses',
          pathDeleteFailed: 'Failed to delete courses',
          thumbnailTooLarge: 'Image size must be less than 5MB',
          invalidImageType: 'Only JPEG, PNG, and WebP images are allowed',
          thumbnailUploadFailed: 'Failed to upload thumbnail',
          clearThumbnail: 'Clear',
          // Additional course management translations
          creating: 'Creating...',
          updating: 'Updating...',
          deletePath: 'Delete Course',
          deleteConfirmText: 'This action cannot be undone.'
        }
      },
      batchManagement: {
        title: 'Batch Management',
        subtitle: 'Manage programs and their respective batches',
        breadcrumb: 'Programs',
        createNewBatch: 'Create New Batch',
        totalBatches: 'Total Batches',
        activePrograms: 'Active Programs',
        totalStudents: 'Total Enrolled Stuednts',
        totalInstructors: 'Total Mentors',
        searchBatches: 'Search batches...',
        runwayType: 'Runway Type',
        allRunways: 'All Programs',
        startYear: 'Start Year',
        allYears: 'All Years',
        status: 'Status',
        allStatus: 'All Status',
        inProgress: 'In Progress',
        completed: 'Completed',
        ongoing: 'In Progress',
        totalBatchesLabel: 'Total Batches',
        noBatchesFound: 'No batches found in this program',
        batchName: 'Batch Name',
        startPeriod: 'Start Period',
        students: 'Students',
        instructors: 'Mentors',
        duration: 'Duration',
        progress: 'Progress',
        actions: 'Actions',
        enrolled: 'Enrolled',
        viewBatchStudents: 'View Batch Students',
        viewBatchInstructors: 'View Batch Mentors',
        viewBatchStructure: 'View Batch Structure',
        editBatchInfo: 'Edit Batch Info',
        deleteBatch: 'Delete Batch',
        editBatch: 'Edit Batch',
        createNewBatchTitle: 'Create New Batch',
        modifyBatchDetails: 'Modify batch details and save changes',
        addNewBatch: 'Add a new batch. You can choose a predefined Program or create a custom one',
        predefinedRunway: 'Predefined Program',
        customRunway: 'Custom Program',
        runwayName: 'Program Name',
        runwayTrack: 'Runway Track',
        selectRunwayTrack: 'Select Program Track',
        batchNamePlaceholder: 'e.g. Batch 001',
        startYearLabel: 'Start Year',
        startMonth: 'Start Month',
        startDate: 'Start Date',
        studentsCount: 'Students Count',
        instructorsCount: 'Mentors Count',
        cancel: 'Cancel',
        saveChanges: 'Save Changes',
        createBatch: 'Create Batch',
        saving: 'Saving...',
        creating: 'Creating...',
        batchUpdated: 'Batch updated successfully!',
        batchCreated: 'Batch created successfully!',
        runwayNamePlaceholder: 'e.g. 6 Months Intensive',
        durationPlaceholder: 'e.g. 6 Months',
        selectCourses: 'Select Courses',
        viewCourses: 'View Courses',
        viewProgress: 'View Progress',
        selectRunways: 'Select Programs',
        selectedProgramCourses: 'Selected Program Courses'
      },
      instructorManagement: {
        title: 'Mentor Management',
        subtitle: 'Manage mentors, courses and batch allocations',
        addInstructor: 'Add Mentor',
        totalInstructors: 'Total Mentors',
        activeInstructors: 'Active Mentors',
        coursesCovered: 'Courses Covered',
        batchesCovered: 'Batches Covered',
        searchInstructor: 'Search mentor...',
        course: 'Course',
        allCourses: 'All Courses',
        batch: 'Batch',
        allBatches: 'All Batches',
        regulation: 'Regulation',
        allRegulations: 'All Regulations',
        resetFilters: 'Reset Filters',
        noInstructorsFound: 'No mentors found',
        tryAdjustingFilters: 'Try adjusting your filters or add a new mentor',
        instructor: 'Mentor',
        subjects: 'Subjects / Specialization',
        status: 'Status',
        actions: 'Actions',
        viewDetails: 'View Details',
        editInstructor: 'Edit Mentor',
        deleteInstructor: 'Delete Mentor',
        instructorDetails: 'Mentor Details',
        teachingInformation: 'Teaching Information',
        activityInformation: 'Activity Information',
        totalStudents: 'Total Students',
        joinDate: 'Join Date',
        lastActive: 'Last Active',
        deactivate: 'Deactivate',
        editInstructorTitle: 'Edit Mentor',
        addNewInstructor: 'Add New Mentor',
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        subjectsLabel: 'Subjects',
        active: 'Active',
        inactive: 'Inactive',
        cancel: 'Cancel',
        saveChanges: 'Save Changes',
        addInstructorBtn: 'Add Mentor',
        instructorNamePlaceholder: 'Enter mentor name',
        emailAddressPlaceholder: 'Enter email address',
        phoneNumberPlaceholder: 'Enter phone number',
        selectCourse: 'Select course',
        selectBatch: 'Select batch',
        selectRegulation: 'Select regulation',
        instructorUpdated: 'Mentor updated successfully',
        instructorAdded: 'Mentor added successfully',
        instructorDeleted: 'Mentor deleted successfully',
        fillRequiredFields: 'Please fill all required fields',
        showing: 'Showing',
        of: 'of',
        instructors: 'mentors',
        previous: 'Previous',
        next: 'Next',
        runway: 'Program',
        module: 'Module'
      },
      studentManagement: {
        title: 'Student Management',
        subtitle: 'Manage students and track attendance and progress across courses',
        searchStudents: 'Search students...',
        filters: 'Filters',
        clearAll: 'Clear All',
        addStudent: 'Add Student',
        totalStudents: 'Total Students',
        colleges: 'Colleges',
        avgAttendance: 'Avg. Attendance',
        avgProgress: 'Avg. Progress',
        acrossAllStudents: 'Across all students',
        courseCompletion: 'Course completion',
        studentsList: 'Students List',
        manageStudentsAndPerformance: 'Manage your students and their performance',
        export: 'Export',
        downloadExcel: 'Download Excel',
        downloadPDF: 'Download PDF',
        filtersLabel: 'Filters:',
        filteredResult: 'Filtered Result',
        students: 'students',
        totalStudentsLabel: 'Total Students',
        batch: 'Batch',
        allBatches: 'All Batches',
        runway: 'Runway',
        allRunways: 'All Programs',
        performance: 'Performance',
        allPerformance: 'All Performance',
        status: 'Status',
        allStatus: 'All Status',
        active: 'Active',
        inactive: 'Inactive',
        suspended: 'Suspended',
        excellent: 'Excellent',
        average: 'Average',
        atRisk: 'At Risk',
        studentId: 'Student ID',
        name: 'Name',
        batchName: 'Batch Name',
        branch: 'Branch',
        startYear: 'Start Year',
        actions: 'Actions',
        viewProfile: 'View Profile',
        editStudent: 'Edit Student',
        activateStudent: 'Activate Student',
        suspendStudent: 'Suspend Student',
        deleteStudent: 'Delete Student',
        attendance: 'Attendance',
        target: 'Target',
        completed: 'Completed',
        testsPassed: 'Tests Passed',
        testsAndStatus: 'Tests & Status',
        lastActive: 'Last Active',
        year: 'Year',
        progress: 'Progress',
        tests: 'Tests',
        modules: 'Modules',
        overview: 'Overview',
        activity: 'Activity',
        edit: 'Edit',
        delete: 'Delete',
        showing: 'Showing',
        of: 'of',
        deleteStudentTitle: 'Delete student?',
        deleteStudentDescription: 'This will remove the student from the system. Enrollment and progress data will be lost.',
        cancel: 'Cancel',
        delete: 'Delete',
        studentUpdated: 'Student updated successfully',
        studentAdded: 'Student added with ID: {{id}}',
        studentActivated: 'Student activated',
        studentSuspended: 'Student suspended',
        studentProgressReset: 'Student progress reset successfully',
        studentDeleted: 'Student deleted',
        filtersCleared: 'Filters cleared',
        excelReportDownloaded: 'Excel report downloaded',
        pdfReportDownloaded: 'PDF report downloaded',
        lowRisk: 'Low Risk',
        mediumRisk: 'Medium Risk',
        highRisk: 'High Risk',
        twoYear: '2 Year',
        threeYear: '3 Year',
        fourYear: '4 Year',
        editStudentProfile: 'Edit Student Profile',
        enrollNewStudent: 'Enroll New Student',
        modifyStudentCredentials: 'Modify student credentials and academic records.',
        fillInformationToEnroll: 'Fill in the information below to enroll a new student in the system.',
        studentName: 'Student Name',
        fullName: 'Full Name',
        collegeBranch: 'College / Branch',
        selectCollege: 'Select college',
        selectedCourse: 'Selected Course',
        selectCourse: 'Select course',
        academicYear: 'Academic Year',
        currentStatus: 'Current Status',
        selectStatus: 'Select status',
        emailAddress: 'Email Address',
        phoneNumber: 'Phone Number',
        attendance: 'Attendance',
        assignments: 'Assignments',
        overallProgress: 'Overall Progress',
        updateProfile: 'Update Profile',
        pleaseEnterStudentName: 'Please enter student name',
        pleaseSelectCollege: 'Please select a college',
        pleaseSelectCourse: 'Please select a course',
        studentProfile: 'Student Profile',
        completeAcademicPerformance: 'Complete academic performance and progress tracking',
        performanceSummary: 'Performance Summary',
        monthlyAttendanceBreakdown: 'Monthly Attendance Breakdown',
        assignmentStatus: 'Assignment Status',
        testPerformance: 'Test Performance',
        moduleProgress: 'Module Progress',
        recentActivity: 'Recent Activity',
        adminActions: 'Admin Actions',
        loginFrequency: 'Login Frequency',
        lastActive: 'Last Active',
        assignmentSubmissions: 'Assignment Submissions',
        testAttempts: 'Test Attempts',
        present: 'Present',
        absent: 'Absent',
        sessions: 'sessions',
        due: 'Due',
        submitted: 'Submitted',
        notSubmitted: 'Not submitted',
        score: 'Score',
        date: 'Date',
        attempts: 'Attempts',
        year: 'Year',
        month: 'Month',
        completed: 'Completed',
        activate: 'Activate',
        suspend: 'Suspend',
        resetProgress: 'Reset Progress',
        noAttendanceData: 'No attendance data available',
        noAssignmentData: 'No assignment data available',
        noTestData: 'No test data available',
        noModuleData: 'No module data available',
        noActivityData: 'No activity data available'
      },
      scheduleManagement: {
        title: 'Schedule Management',
        subtitle: 'ACADEMIC TRACK',
        breadcrumb: 'SCHEDULE HUB',
        addSchedule: 'Add Schedule',
        academicCalendar: 'Academic Calendar',
        searchSchedules: 'Search schedules...',
        allRunways: 'All Programs',
        allBatches: 'All Batches',
        selectRunwayFirst: 'Select program first',
        allBatchesText: 'All Batches',
        list: 'LIST',
        calendar: 'CALENDAR',
        noSchedulesFound: 'No schedules found',
        tryAdjustingFilters: 'Try adjusting your search or filters, or create a new schedule.',
        createFirstSchedule: 'Create First Schedule',
        upcoming: 'UPCOMING',
        liveNow: 'LIVE NOW',
        completed: 'COMPLETED',
        editSession: 'Edit Session',
        deleteTask: 'Delete Task',
        launch: 'LAUNCH',
        instructor: 'Mentor',
        batch: 'BATCH',
        mode: 'Mode',
        scheduleSession: 'Schedule Session',
        clickToEdit: 'Click to edit',
        clickToSeeAll: 'Click to see all',
        more: 'more',
        editSchedule: 'Edit Schedule',
        addNewSchedule: 'Add New Schedule',
        updateSchedule: 'Update Schedule',
        newScheduleCreated: 'New schedule created',
        scheduleUpdated: 'Schedule updated',
        scheduleDeleted: 'Schedule deleted',
        areYouSureDelete: 'Are you sure you want to delete this schedule?',
        pleaseFillRequiredFields: 'Please fill in all required fields',
        runway: 'Program',
        batchLabel: 'Batch',
        date: 'Date',
        time: 'Time',
        sessionTitle: 'Session Title',
        description: 'Description',
        instructorLabel: 'Mentor',
        roomLocation: 'Room/Location',
        meetingRoom: 'Meeting Room',
        meetingLink: 'Meeting Link',
        online: 'Online',
        offline: 'Offline',
        selectRunway: 'Select program',
        selectBatch: 'Select batch',
        selectInstructor: 'Select mentor',
        updateScheduleDetails: 'Update schedule details below',
        fillInformationToCreate: 'Fill in details to create a new schedule',
        cancel: 'Cancel',
        createSchedule: 'Create Schedule'
      },
      assessmentManagement: {
        assignment: 'Assignments',
        subtitle: 'Manage and monitor student tasks across batches',
        createAssessment: 'Create Assignment',
        totalActive: 'Total Active',
        published: 'Published',
        upcomingDeadlines: 'Upcoming Deadlines',
        totalSubmissions: 'Total Submissions',
        searchAssessment: 'Search assignment title...',
        runway: 'Runway',
        batch: 'Batch',
        status: 'Status',
        allRunways: 'All Programs',
        allBatches: 'All Batches',
        allStatus: 'All Status',
        draft: 'Draft',
        closed: 'Closed',
        title: 'Title',
        instructor: 'Mentor',
        deadline: 'Deadline',
        submissions: 'Submissions',
        actions: 'Actions',
        viewDetails: 'View Details',
        editAssessment: 'Edit Assignment',
        viewSubmissions: 'View Submissions',
        delete: 'Delete',
        noAssessmentsMatch: 'No assignments found',
        showingAssessments: 'Showing {{count}} assignments',
        previous: 'Previous',
        next: 'Next',
        backToAssessments: 'Back to Assignments',
        submissionOverview: 'Submission Overview & Student Performance',
        exportCSV: 'Export CSV',
        contactPending: 'Contact Pending',
        avgEvaluationTAT: 'Avg. Evaluation TAT',
        turnaroundTime: 'Turnaround Time',
        submissionRate: 'Submission Rate',
        evaluationProgress: 'Evaluation Progress',
        assignedInstructors: 'Assigned Mentors',
        active: 'Active',
        studentSubmissions: 'Student Submissions',
        realTimeTracking: 'Real-time tracking of assignment progress',
        searchStudent: 'Search student...',
        selectBatch: 'Select Batch',
        noStudentsFound: 'No students found matching your filters.',
        showingStudents: 'Showing {{current}} of {{total}} Students',
        page: 'Page {{current}} of {{total}}',
        submissionContent: 'Submission Content',
        repositoryURL: 'Repository URL',
        liveDemo: 'Live Demo',
        studentNotes: 'Student Notes',
        noAdditionalNotes: 'No additional notes provided by the student.',
        evaluationStatus: 'Evaluation Status',
        currentStatus: 'Current Status',
        evaluated: 'Evaluated',
        submitted: 'Submitted',
        pending: 'Pending',
        finalGrade: 'Final Grade',
        gradeAssessment: 'Grade Assignment',
        student: 'Student',
        submission: 'Submission',
        reviewTAT: 'Review TAT',
        marks: 'Marks',
        quickView: 'Quick View',
        evaluate: 'Evaluate',
        viewSubmissionHistory: 'View Submission History',
        downloadAllFiles: 'Download All Files',
        resetSubmission: 'Reset Submission',
        noSubmission: 'No Submission'
      },
      assessmentForm: {
        backToAssessments: 'Back to Assignments',
        editAssessment: 'Edit Assignment',
        createAssessment: 'Create Assignment',
        updating: 'Updating: {{id}}',
        designNewTask: 'Design a new task for students to complete',
        saveDraft: 'Save Draft',
        publish: 'Publish',
        basicInformation: 'Basic Information',
        assessmentTitle: 'Assignment Title',
        titlePlaceholder: 'e.g., Build Authentication API',
        description: 'Description',
        descriptionPlaceholder: 'Brief overview of assignment...',
        descriptionHelp: 'Summarize what student will learn from this task.',
        detailedInstructions: 'Detailed Instructions',
        instructionsPlaceholder: 'Step-by-step instructions for student...',
        attachments: 'Attachments',
        uploadText: 'Click to upload or drag and drop',
        uploadHelp: 'PDF, DOCX, ZIP (Max 10MB)',
        evaluationGrading: 'Evaluation & Grading',
        maxMarks: 'Maximum Marks',
        passingMarks: 'Passing Marks',
        evaluationRubric: 'Evaluation Rubric',
        addCriteria: 'Add criteria',
        rubricPlaceholder: 'Define criteria for evaluation (e.g., Code Quality, Functionality...)',
        academicDetails: 'Academic Details',
        runway: 'Program',
        selectRunway: 'Select Program',
        course: 'Course',
        selectCourse: 'Select Course',
        batchSubBatch: 'Batch / Sub-batch',
        selectBatch: 'Select Batch',
        deadline: 'Deadline',
        assignInstructor: 'Assign Mentor',
        selectInstructor: 'Select Mentor',
        instructorHelp: 'The assigned mentor will be responsible for evaluating all student submissions for this assignment.',
        publicationStatus: 'Publication Status',
        neverPublished: 'Never Published',
        newAssessment: 'New Assignment',
        publishWarning: 'Publishing this assignment will immediately notify all students in selected batch(es).',
        module: 'Module',
        lesson: 'Lesson',
        topic: 'Topic',
        content: 'Content',
        selectModule: 'Select Module',
        selectLesson: 'Select Lesson',
        selectTopic: 'Select Topic',
        selectContent: 'Select Content',
        loadingModules: 'Loading modules...',
        loadingLessons: 'Loading lessons...',
        loadingTopics: 'Loading topics...',
        loadingContent: 'Loading content...',
        noModulesAvailable: 'No modules available for selected course',
        noLessonsAvailable: 'No lessons available for selected module',
        noTopicsAvailable: 'No topics available for selected lesson',
        noContentAvailable: 'No content available for selected topic'
      },
      assignmentManagement: {
        title: 'Exam Portal',
        subtitle: 'Create, distribute and manage global student exams.',
        control: 'Exams Control',
        createAssignment: 'Create Exam',
        totalAssignments: 'Total Exams',
        totalMarks: 'Total Marks',
        assignedCoursesCount: 'Assigned Courses',
        searchAssignments: 'Search exams...',
        allSubjects: 'All Subjects',
        allRunways: 'All Programs',
        programming: 'Programming',
        aptitude: 'Aptitude',
        mathematics: 'Mathematics',
        assignmentDetails: 'Exam Details',
        distribution: 'Distribution',
        marksTime: 'Marks/Time',
        status: 'Status',
        actions: 'Actions',
        batches: 'Batches',
        marks: 'MARKS',
        mins: 'MINS',
        live: 'LIVE',
        draft: 'DRAFT',
        questions: 'Questions',
        view: 'View',
        edit: 'Edit',
        delete: 'Delete',
        createNewAssignment: 'Create New Exam',
        step1BasicInfo: 'Step 1: Basic Information',
        cancel: 'Cancel',
        saveContinue: 'Save & Continue',
        assignmentTitle: 'EXAM TITLE',
        titlePlaceholder: 'e.g. Master Advanced React Patterns',
        subject: 'SUBJECT',
        targetLevel: 'TARGET LEVEL',
        totalMarks: 'TOTAL MARKS',
        difficulty: 'DIFFICULTY',
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        assignmentDescription: 'EXAM DESCRIPTION',
        descriptionPlaceholder: 'Explain the objectives and requirements of this exam...',
        tagsKeywords: 'TAGS & KEYWORDS',
        separateByCommas: 'SEPARATE BY COMMAS',
        tagsPlaceholder: 'react, frontend, hooks, level-3',
        whatHappensNext: 'What happens next?',
        nextStepInfo: 'After saving this information, you will be redirected to **Question Manager** where you can start adding questions to this assignment.',
        allCourses: 'All Courses',
        allExamTypes: 'All Exam Types',
        basicExam: 'Basic Exam',
        masterTest: 'Master Test',
        finalExam: 'Final Exam',
        contentTest: 'Content Test'
      },
      assignmentForm: {
        backToDashboard: 'Back to Dashboard',
        cancel: 'Cancel',
        saving: 'Saving...',
        updateAssignment: 'Update Exam',
        createAssignment: 'Create Exam',
        editAssignment: 'Edit Exam',
        newAssignment: 'New Exam',
        draft: 'Draft',
        setupParameters: 'Setup your exam parameters and evaluation rubrics.',
        generalInformation: 'General Information',
        assignmentTitle: 'Assignment Title',
        titlePlaceholder: 'e.g. Advanced React Design Patterns',
        category: 'Category',
        categoryPlaceholder: 'e.g. Frontend Development',
        assignmentType: 'Assignment Type',
        selectType: 'Select type',
        standardSubmission: 'Standard Submission',
        codeRepository: 'Code Repository',
        interactiveQuiz: 'Interactive Quiz',
        description: 'Description',
        descriptionPlaceholder: 'Provide detailed instructions for students...',
        academicContext: 'Academic Context',
        targetRunway: 'Target Program',
        selectRunway: 'Select Program',
        targetBatch: 'Target Batch',
        selectBatch: 'Select Batch',
        selectRunwayFirst: 'Select Program First',
        submissionEvaluation: 'Submission & Evaluation',
        dueDateTime: 'Due Date & Time',
        totalMarks: 'Total Marks',
        scoringRubrics: 'Scoring Rubrics',
        addCriterion: 'Add Criterion',
        rubricInfo: 'Setup criteria for structured evaluation. The sum of rubric points should ideally match total marks.',
        criterionPlaceholder: 'Criterion {{index}} (e.g. Code Architecture)',
        max: 'Max',
        totalRubricWeight: 'Total Rubric Weight',
        saveChanges: 'Save Changes',
        publishAssignment: 'Publish Assignment',
        assignmentNotFound: 'Exam not found',
        assignmentCreated: 'Exam created successfully',
        assignmentUpdated: 'Exam updated successfully'
      },
      questionManager: {
        contentManagement: 'Content Management',
        assignmentId: 'Exam ID: {{id}}',
        addQuestion: 'Add Question',
        questions: 'Questions',
        totalQuestions: 'Total Questions',
        totalMarks: 'Total Marks',
        estimatedTime: 'Estimated Time',
        options: 'Options',
        tfOptions: 'T/F Options',
        programming: 'Programming',
        writeAnswer: 'Write Answer',
        keySet: 'Key Set',
        edit: 'Edit',
        duplicate: 'Duplicate',
        delete: 'Delete',
        addQuestionToSet: 'Add Question to set'
      },
      distributionPage: {
        manageDistribution: 'Manage Distribution',
        assignmentId: 'Exam ID: {{id}}',
        applySyncDistribution: 'Apply & Sync Distribution',
        targetRunways: '1. Target program',
        targetBatches: '2. Target Batches',
        selectAll: 'Select All',
        filterBatches: 'Filter batches...',
        students: 'Students',
        viewStudents: 'View Students',
        availabilityControls: '3. Availability Controls',
        startDateTime: 'START DATE & TIME',
        endDateTime: 'END DATE & TIME',
        keepOpen: 'Keep open (No deadline)',
        liveStatus: 'Live Status',
        eligibilityEngine: 'Eligibility Engine',
        studentsWillReceive: 'Students will receive access instantly.',
        runways: 'Programs',
        batches: 'Batches',
        conflictCheck: 'Conflict Check',
        clean: 'CLEAN',
        selected: 'Selected',
        confirmDistribution: 'Confirm Distribution'
      },
      attendance: {
        markAttendance: 'Mark Attendance',
        efficiencyMarking: 'Efficiency marking tools for large runway batches.',
        attendanceHistory: 'Attendance History',
        report: 'Report',
        runway: 'Program',
        year: 'Year',
        batch: 'Batch',
        date: 'Date',
        searchByNameBatch: 'Search by name...',
        studentList: 'Student List',
        markAllPresent: 'Mark All Present',
        markAllAbsent: 'Mark All Absent',
        markAll: 'Marked all as {{status}}',
        attendanceReset: 'Attendance reset',
        attendanceSummary: 'Attendance Summary',
        attendanceRate: 'Attendance Rate',
        total: 'Total',
        present: 'Present',
        absent: 'Absent',
        marked: 'Marked: {{count}}',
        remaining: 'Remaining: {{count}}',
        saveAsDraft: 'Save as Draft',
        saveAttendance: 'SAVE ATTENDANCE',
        attendanceRecorded: 'Attendance recorded successfully!',
        markAllStudents: 'Please mark attendance for all {{count}} students.',
        noStudentsFound: 'No students found for this batch.',
        markedOfTotal: 'Marked {{marked}} of {{total}} students',
        presentStatus: 'Present',
        absentStatus: 'Absent'
      },
      attendanceHistory: {
        attendanceHistory: 'Attendance History',
        backToMarking: 'Back to Marking',
        goBack: 'Go Back',
        allYears: 'All Years',
        customRange: 'Custom Range',
        viewYearly: 'View Yearly',
        exportData: 'Export Data',
        searchHistory: 'Search history...',
        allBatches: 'All Batches',
        yearlyAttendance: 'Yearly Attendance',
        monthsInYear: 'Months in {{year}}',
        dailySessions: 'Daily Sessions',
        customRangeSearch: 'Custom Range Search',
        records: 'Records',
        title: 'Title',
        sessions: 'Sessions',
        avgTotalPresent: 'Avg/Total Present',
        avgTotalAbsent: 'Avg/Total Absent',
        status: 'Status',
        view: 'View',
        fullAcademicYear: 'Full Academic Year {{year}}',
        monthlyConsolidated: 'Monthly Consolidated',
        recordedOn: 'Recorded on {{date}}',
        days: 'Days',
        noHistoryFound: 'No history found',
        expandSearch: 'Expand your search or check another period.',
        customRangeLabel: 'Custom Range'
      },
      adminPanel: {
        adminPanel: 'Admin Panel',
        comprehensiveManagement: 'Comprehensive platform management',
        overview: 'Overview',
        users: 'Users',
        courses: 'Courses',
        jobs: 'Jobs',
        analytics: 'Analytics',
        logs: 'Activity Logs',
        settings: 'Settings',
        totalUsers: 'Total Users',
        totalCourses: 'Total Courses',
        activeJobs: 'Active Jobs',
        revenue: 'Revenue',
        inLast7Days: '+{{count}} in last 7 days',
        published: '{{count}} published',
        applications: '{{count}} applications',
        fromLastMonth: '+{{count}}% from last month',
        userDistributionByRole: 'User Distribution by Role',
        students: 'Students',
        instructors: 'Mentors',
        admins: 'Admins',
        quickActions: 'Quick Actions',
        manageUsers: 'Manage Users',
        manageCourses: 'Manage Courses',
        manageJobs: 'Manage Jobs',
        failedToFetchDashboard: 'Failed to fetch dashboard data'
      },
      superAdminInstitutes: {
        instituteManagement: 'Institute Management',
        manageAllInstitutes: 'Manage all institutes',
        createInstitute: 'Create Institute',
        total: 'Total',
        active: 'Active',
        pending: 'Pending',
        suspended: 'Suspended',
        allInstitutes: 'All Institutes',
        plans: 'Plans',
        search: 'Search...',
        allStatus: 'All Status',
        loading: 'Loading...',
        noInstitutes: 'No Institutes found',
        noPendingRequests: 'No pending requests',
        view: 'View',
        activate: 'Activate',
        suspend: 'Suspend',
        delete: 'Delete',
        approve: 'Approve',
        reject: 'Reject',
        create: 'Create',
        cancel: 'Cancel',
        unlimited: 'Unlimited',
        students: 'Students',
        courses: 'Courses',
        storage: 'Storage',
        slug: 'Slug',
        email: 'Email',
        description: 'Description',
        city: 'City',
        country: 'Country',
        name: 'Name',
        status: 'Status',
        users: 'Users',
        approveRequest: 'Approve Request?',
        rejectRequest: 'Reject Request?',
        reason: 'Reason...',
        instituteCreated: 'Institute created',
        activated: 'Activated',
        suspended: 'Suspended',
        deleted: 'Deleted',
        approved: 'Approved!',
        rejected: 'Rejected',
        failedToLoadData: 'Failed to load data',
        failed: 'Failed',
        deleteConfirm: 'Delete?',
        failedToLoadDetails: 'Failed to load details'
      },
      userManagement: {
        userManagement: 'User Management',
        managePlatformUsers: 'Manage platform users and roles',
        addUser: 'Add User',
        searchUsers: 'Search users by email or name...',
        id: 'ID',
        email: 'Email',
        name: 'Name',
        role: 'Role',
        joined: 'Joined',
        student: 'Student',
        instructor: 'Mentor',
        admin: 'Admin',
        editUser: 'Edit User',
        createNewUser: 'Create New User',
        updateUser: 'Update user information',
        addNewUser: 'Add a new user to platform',
        fullName: 'Full Name',
        password: 'Password',
        leaveEmptyToKeepCurrent: '(leave empty to keep current)',
        deleteUser: 'Delete user',
        userDeletedSuccessfully: 'User deleted successfully',
        userCreatedSuccessfully: 'User created successfully',
        userUpdatedSuccessfully: 'User updated successfully',
        roleUpdatedSuccessfully: 'Role updated successfully',
        failedToFetchUsers: 'Failed to fetch users',
        failedToDeleteUser: 'Failed to delete user',
        failedToUpdateRole: 'Failed to update role',
        operationFailed: 'Operation failed',
        deleteUserConfirm: 'Delete user {{email}}?',
        update: 'Update',
        create: 'Create',
        cancel: 'Cancel'
      },
      jobManagement: {
        jobManagement: 'Job Management',
        manageJobs: 'Manage job postings and applications',
        addJob: 'Add Job',
        searchJobs: 'Search jobs...',
        id: 'ID',
        jobTitle: 'Job Title',
        location: 'Location',
        type: 'Type',
        salary: 'Salary',
        remote: 'Remote',
        notSpecified: 'Not specified',
        editJob: 'Edit Job',
        createNewJob: 'Create New Job',
        updateJob: 'Update job posting',
        addNewJob: 'Add a new job posting',
        company: 'Company',
        jobType: 'Job Type',
        fullTime: 'Full Time',
        partTime: 'Part Time',
        contract: 'Contract',
        internship: 'Internship',
        salaryRange: 'Salary Range',
        description: 'Description',
        requirements: 'Requirements',
        listRequirements: 'List requirements (one per line)',
        deleteJob: 'Delete job',
        jobDeletedSuccessfully: 'Job deleted successfully',
        jobCreatedSuccessfully: 'Job created successfully',
        jobUpdatedSuccessfully: 'Job updated successfully',
        failedToFetchJobs: 'Failed to fetch jobs',
        failedToDeleteJob: 'Failed to delete job',
        operationFailed: 'Operation failed',
        deleteJobConfirm: 'Delete job "{{title}}"?',
        update: 'Update',
        create: 'Create',
        cancel: 'Cancel'
      },
      analyticsDashboard: {
        analyticsDashboard: 'Analytics Dashboard',
        platformPerformance: 'Platform performance and insights',
        revenue: 'Revenue',
        users: 'Users',
        courses: 'Courses',
        engagement: 'Engagement',
        revenueOverview: 'Revenue Overview',
        last7Days: 'Last 7 Days',
        last30Days: 'Last 30 Days',
        lastQuarter: 'Last Quarter',
        lastYear: 'Last Year',
        totalRevenue: 'Total Revenue',
        transactions: 'Transactions',
        avgTransaction: 'Avg. Transaction',
        perTransaction: 'Per transaction',
        acrossAllPaymentMethods: 'Across all payment methods',
        fromLastPeriod: '+{{count}}% from last period',
        revenueTrend: 'Revenue Trend',
        chartVisualization: 'Chart visualization would go here (integrate Chart.js or Recharts)',
        userAnalytics: 'User Analytics',
        userGrowth: 'User Growth',
        userActivity: 'User Activity',
        userGrowthChart: 'User growth chart would go here',
        activityHeatmap: 'Activity heatmap would go here',
        courseAnalytics: 'Course Analytics',
        mostPopularCourses: 'Most Popular Courses',
        coursePopularityChart: 'Course popularity chart would go here',
        platformEngagement: 'Platform Engagement',
        dailyActiveUsers: 'Daily Active Users',
        sessionDuration: 'Session Duration',
        dauChart: 'DAU chart would go here',
        sessionDurationChart: 'Session duration chart would go here',
        failedToFetchRevenueData: 'Failed to fetch revenue data'
      },
      activityLogs: {
        activityLogs: 'Activity Logs',
        trackSystemActivities: 'Track system activities and changes',
        noActivityLogsFound: 'No activity logs found',
        create: 'Create',
        update: 'Update',
        delete: 'Delete',
        user: 'User',
        failedToFetchActivityLogs: 'Failed to fetch activity logs'
      },
      systemSettings: {
        systemSettings: 'System Settings',
        configurePlatform: 'Configure platform-wide settings',
        saveChanges: 'Save Changes',
        saving: 'Saving...',
        general: 'General',
        security: 'Security',
        email: 'Email',
        advanced: 'Advanced',
        siteName: 'Site Name',
        siteDescription: 'Site Description',
        supportEmail: 'Support Email',
        maxUploadSize: 'Max Upload Size (MB)',
        enableUserRegistrations: 'Enable User Registrations',
        allowNewUsersToRegister: 'Allow new users to register on platform',
        requireEmailVerification: 'Require Email Verification',
        usersMustVerifyEmail: 'Users must verify their email before accessing platform',
        enableTwoFactor: 'Enable Two-Factor Authentication',
        allowUsersToEnable2FA: 'Allow users to enable 2FA for their accounts',
        sessionTimeout: 'Session Timeout (minutes)',
        emailSettingsConfigured: 'Email settings are configured via environment variables (SMTP server, credentials, etc.)',
        requiredEnvironmentVariables: 'Required Environment Variables:',
        maintenanceMode: 'Maintenance Mode',
        maintenanceWarning: '⚠️ This will make the platform inaccessible to all users except admins',
        databaseBackup: 'Database Backup',
        downloadDatabaseBackup: 'Download Database Backup',
        clearCache: 'Clear Cache',
        clearSystemCache: 'Clear System Cache',
        settingsSavedSuccessfully: 'Settings saved successfully',
        failedToFetchSettings: 'Failed to fetch system settings',
        failedToSaveSettings: 'Failed to save settings'
      },
      profile: {
        profile: 'Profile',
        memberSince: 'Member since {{year}}',
        totalPoints: 'Total Points',
        currentStreak: 'Current Streak',
        globalRank: 'Global Rank',
        enrolledCourses: 'Enrolled Courses',
        keepLearning: 'Keep learning!',
        dontBreakIt: 'Don\'t break it!',
        topPerformer: 'Top performer!',
        activeLearning: 'Active learning',
        achievements: 'Achievements',
        firstCourse: 'First Course',
        enrolledInFirstCourse: 'Enrolled in your first course',
        weekWarrior: 'Week Warrior',
        sevenDayStreak: '7-day learning streak',
        courseCompleter: 'Course Completer',
        completeFirstCourse: 'Complete first course',
        failedToFetchStats: 'Failed to fetch stats'
      },
      settings: {
        settings: 'Settings',
        managePreferences: 'Manage your preferences',
        appearance: 'Appearance',
        customizeAppLook: 'Customize how the app looks',
        darkMode: 'Dark Mode',
        enableDarkTheme: 'Enable dark theme',
        language: 'Language',
        choosePreferredLanguage: 'Choose your preferred language',
        notifications: 'Notifications',
        manageNotificationPreferences: 'Manage notification preferences',
        emailNotifications: 'Email notifications',
        pushNotifications: 'Push notifications',
        courseUpdates: 'Course updates'
      },
      sidebar: {
        courseManagement: 'Course Management',
        batchManagement: 'Batch Management',
        instructorManagement: 'Mentor Management',
        studentManagement: 'Student Management',
        scheduleManagement: 'Schedule Management',
        assessments: 'Assignments',
        assignmentManagement: 'Assignment Management',
        markAttendance: 'Mark Attendance',
        attendanceHistory: 'Attendance History',
        institutes: 'Institutes',
        instituteAnalytics: 'Institute Analytics',
        branding: 'Branding',
        instructorDashboard: 'Mentor Dashboard',
        batchSchedule: 'Batch Schedule',
        assessmentsManagement: 'Assignments Management',
        managePanel: 'Manage Panel',
        liveClasses: 'Live Classes',
        testsQuiz: 'Tests/Quiz',
        assignments: 'Assignments',
        bookmarks: 'Bookmarks',
        codeLab: 'Code Lab',
        darkMode: 'Dark Mode',
        lightMode: 'Light Mode',
        logout: 'Logout',
        superAdmin: 'SuperAdmin',
        runwayManagement: 'Program Management',
        payments: 'Payments',
        paymentHistory: 'Payment History',
        paymentManagement: 'Payment Management',
        studentPaymentSupport: 'Student Payment Support'
      },
      runway: {
        title: 'Program Management',
        subtitle: 'Manage program information and descriptions',
        runwayName: 'Program Name',
        description: 'Description',
        createRunway: 'Create Program',
        editRunway: 'Edit Program',
        deleteRunway: 'Delete Program',
        searchRunways: 'Search programs...',
        totalRunways: 'Total Programs',
        actions: 'Actions',
        noRunwaysFound: 'No programs found',
        createFirstRunway: 'Create your first runway',
        runwayNamePlaceholder: 'e.g., R1 - Foundation Track',
        descriptionPlaceholder: 'Describe the runway purpose and content...',
        confirmDelete: 'Are you sure you want to delete this program?',
        runwayCreated: 'Runway created successfully',
        runwayUpdated: 'Runway updated successfully',
        runwayDeleted: 'Runway deleted successfully',
        errorCreating: 'Failed to create runway',
        errorUpdating: 'Failed to update runway',
        errorDeleting: 'Failed to delete runway',
        errorLoading: 'Failed to load runways'
      }
    }
  },
  ar: {
    translation: {
      welcome: 'أهلا بك',
      courses: 'الدورات',
      myCourses: 'دوراتي',
      leaderboard: 'لوحة المتصدرين',
      tests: 'الاختبارات والتقييمات',
      assignments: 'الواجبات',
      companyQuestions: 'أسئلة الشركات',
      jobs: 'الوظائف والتدريب',
      bookmarks: 'المفضلة',
      profile: 'الملف الشخصي',
      chat: 'الدردشة',
      notifications: 'الإشعارات',
      settings: 'الإعدادات',
      logout: 'تسجيل الخروج',
      payments: 'المدفوعات',
      paymentManagement: 'إدارة المدفوعات',
      paymentHistory: 'سجل المدفوعات',
      makePayment: 'إجراء دفعة',
      paymentSummary: 'ملخص الدفعة',
      offlinePayment: 'دفععة غير متصلة',
      onlinePayment: 'دفععة عبر الإنترنت',
      paymentStatus: 'حالة الدفعة',
      transactionId: 'رقم المعاملة',
      receipt: 'إيصال',
      balance: 'الرصيد',
      paidAmount: 'المبلغ المدفوع',
      totalCost: 'التكلفة الإجمالية',
      runwayPayment: 'دفععة المسار',
      selectRunways: 'اختر المسارات',
      paymentDetails: 'تفاصيل الدفعة',
      addOfflinePayment: 'إضافة دفعة غير متصلة',
      paymentAnalytics: 'تحليلات المدفوعات',
      totalPayments: 'إجمالي المدفوعات',
      successfulPayments: 'المدفوعات الناجحة',
      pendingPayments: 'المدفوعات المعلقة',
      collectPayment: 'جمع الدفعة',
      studentPaymentSupport: 'دعم دفعات الطلاب',
      paymentCollection: 'جمع المدفوعات',
      batchStudents: 'طلاب الدفعة',
      batchRunways: 'مسارات الدفعة',
      selectBatch: 'اختر الدفعة',
      selectStudent: 'اختر الطالب',
      processOfflinePayment: 'معالجة الدفعة غير المتصلة',
      paymentInitiated: 'تم بدء الدفعة',
      paymentConfirmed: 'تم تأكيد الدفعة',
      paymentFailed: 'فشلت الدفعة',
      paymentReceipt: 'إيصال الدفعة',
      receiptNumber: 'رقم الإيصال',
      payerName: 'اسم الدافع',
      paymentMode: 'طريقة الدفع',
      paymentRemarks: 'ملاحظات الدفعة',
      itemsSelected: 'العناصر المحددة',
      currentPaymentSummary: 'ملخص الدفعة الحالي',
      paymentProgress: 'تقدم الدفعة',
      payNow: 'ادفع الآن',
      downloadReceipt: 'تحميل الإيصال',
      viewReceipt: 'عرض الإيصال',
      paymentComplete: 'الدفعة مكتملة',
      paymentPending: 'الدفعة معلقة',
      login: 'تسجيل الدخول',
      register: 'تسجيل حساب جديد',
      email: 'البريد الإلكتروني',
      password: 'كلمة المرور',
      fullName: 'الاسم الكامل',
      submit: 'إرسال',
      cancel: 'إلغاء',
      save: 'حفظ',
      delete: 'حذف',
      edit: 'تعديل',
      view: 'عرض',
      enrollNow: 'سجل الآن',
      startLearning: 'ابدأ التعلم',
      continueLearning: 'استكمل التعلم',
      completed: 'مكتمل',
      inProgress: 'قيد التقدم',
      notStarted: 'لم يبدأ',
      streak: 'السلسلة',
      points: 'النقاط',
      rank: 'الترتيب',
      totalLessons: 'إجمالي الدروس',
      completedLessons: 'الدروس المكتملة',
      collegeManagement: {
        title: 'إدارة الدورات',
        subtitle: 'تدريب عبر الإنترنت - دورات حسب المسار (R1/R2/R3)، منهج منفصل لكل مسار، ودروس السبت والأحد',
        editCollege: 'تعديل الكلية',
        batches: 'الدفعات',
        students: 'الطلاب',
        contactAndLocation: 'معلومات التواصل والموقع',
        totalStudents: 'إجمالي الطلاب',
        activeBatches: 'الدفعات النشطة',
        academicPaths: 'المسارات الأكاديمية',
        yearStarted: 'سنة البداية',
        managementPathAndCurriculum: 'مسار الإدارة والمنهج',
        managementPathDescription: 'إدارة المسارات الأكاديمية ومستويات الالتحاق وموارد المنهج',
        addPath: 'إضافة مسار',
        satSunClasses: 'حصص السبت والأحد',
        download: 'تنزيل',
        noManagementPaths: 'لم يتم إنشاء أي مسارات إدارة بعد.',
        createFirstPath: 'إنشاء أول مسار',
        noCollegeRegistered: 'لا توجد كلية مسجلة. أضف كلية للبدء.',
        editCollegeDescription: 'حدّث تفاصيل الكلية ومعلومات التواصل.',
        collegeName: 'اسم الكلية',
        location: 'الموقع',
        contactDetails: 'تفاصيل التواصل',
        updateCollege: 'تحديث الكلية',
        editManagementPath: 'تعديل مسار الإدارة',
        createManagementPath: 'إنشاء مسار إدارة',
        definePathDetails: 'حدد التفاصيل والمسار والمدة لهذا المسار.',
        pathName: 'اسم المسار',
        applicableRunway: 'المسار المناسب',
        selectRunway: 'اختر المسار',
        batchLabel: 'رمز الدفعة',
        pathDuration: 'مدة المسار',
        description: 'الوصف',
        updatePath: 'تحديث المسار',
        createPath: 'إنشاء مسار',
        defaultPathDescription: 'منهج شامل مع نقاط دخول مرنة.',
        deleteConfirmTitle: 'حذف المسار؟',
        deleteConfirmText: 'لا يمكن التراجع عن هذا الإجراء.',
        loadingPaths: 'جاري تحميل المسارات...',
        updateFailed: 'فشل في تحديث تفاصيل المعهد',
        placeholders: {
          collegeName: 'مثال: كلية الهندسة ABC',
          location: 'المدينة أو المنطقة',
          contactPerson: 'اسم مسؤول التواصل',
          email: 'البريد الإلكتروني',
          phone: 'رقم الهاتف',
          pathName: 'مثال: مسار تطوير البرمجيات',
          batchLabel: 'مثال: BT1',
          pathDuration: 'مثال: 4 سنوات',
          description: 'اكتب باختصار ما يغطيه هذا المسار...'
        },
        toast: {
          enterCollegeName: 'يرجى إدخال اسم الكلية',
          collegeUpdated: 'تم تحديث الكلية بنجاح',
          pathNameRunwayRequired: 'اسم المسار واختيار المسار مطلوبان',
          pathUpdated: 'تم تحديث {{runway}} بنجاح',
          pathCreated: 'تم إنشاء {{runway}} جديد',
          pathRemoved: 'تمت إزالة المسار',
          downloadingCurriculum: 'جاري تنزيل منهج {{runway}}...',
          pathLoadFailed: 'فشل في تحميل المسارات',
          pathSaveFailed: 'فشل في حفظ المسار',
          pathDeleteFailed: 'فشل في حذف المسار'
        }
      },
      batchManagement: {
        title: 'إدارة البرامج',
        subtitle: 'إدارة مسارات المدرج والدفعات التابعة لها',
        breadcrumb: 'البرامج',
        createNewBatch: 'إنشاء دفعة جديدة',
        totalBatches: 'إجمالي الدفعات',
        activePrograms: 'البرامج النشطة',
        totalStudents: 'إجمالي الطلاب',
        totalInstructors: 'إجمالي المدربين',
        searchBatches: 'البحث عن الدفعات...',
        runwayType: 'نوع المدرج',
        allRunways: 'جميع المدارج',
        startYear: 'سنة البدء',
        allYears: 'جميع السنوات',
        status: 'الحالة',
        allStatus: 'جميع الحالات',
        inProgress: 'قيد التنفيذ',
        completed: 'مكتمل',
        totalBatchesLabel: 'إجمالي الدفعات',
        noBatchesFound: 'لم يتم العثور على دفعات في هذا المدرج',
        batchName: 'اسم الدفعة',
        startPeriod: 'فترة البدء',
        students: 'الطلاب',
        instructors: 'المدربون',
        duration: 'المدة',
        progress: 'التقدم',
        actions: 'الإجراءات',
        enrolled: 'المسجلون',
        viewBatchStudents: 'عرض طلاب الدفعة',
        viewBatchInstructors: 'عرض مدربي الدفعة',
        viewBatchStructure: 'عرض هيكل الدفعة',
        editBatchInfo: 'تعديل معلومات الدفعة',
        deleteBatch: 'حذف الدفعة',
        editBatch: 'تعديل الدفعة',
        createNewBatchTitle: 'إنشاء دفعة جديدة',
        modifyBatchDetails: 'تعديل تفاصيل الدفعة وحفظ التغييرات',
        addNewBatch: 'إضافة دفعة جديدة. يمكنك اختيار مدرج محدد مسبقًا أو إنشاء مدرج مخصص',
        predefinedRunway: 'مدرج محدد مسبقًا',
        customRunway: 'مدرج مخصص',
        runwayName: 'اسم المدرج',
        runwayTrack: 'مسار المدرج',
        selectRunwayTrack: 'اختر مسار المدرج',
        batchNamePlaceholder: 'مثال: الدفعة 001',
        startYearLabel: 'سنة البدء',
        startMonth: 'شهر البدء',
        studentsCount: 'عدد الطلاب',
        instructorsCount: 'عدد المدربين',
        cancel: 'إلغاء',
        saveChanges: 'حفظ التغييرات',
        createBatch: 'إنشاء دفعة',
        saving: 'جاري الحفظ...',
        creating: 'جاري الإنشاء...',
        batchUpdated: 'تم تحديث الدفعة بنجاح!',
        batchCreated: 'تم إنشاء الدفعة بنجاح!',
        runwayNamePlaceholder: 'مثال: 6 أشهر مكثفة',
        durationPlaceholder: 'مثال: 6 أشهر',
        selectCourses: 'اختر الدورات',
        viewCourses: 'عرض الدورات',
        viewProgress: 'عرض التقدم',
        selectRunways: 'اختر المدارج',
        selectedProgramCourses: 'دورات البرنامج المحددة'
      },
      instructorManagement: {
        title: 'إدارة المدربين',
        subtitle: 'إدارة المدربين والدورات وتخصيصات الدفعات',
        addInstructor: 'إضافة مدرب',
        totalInstructors: 'إجمالي المدربين',
        activeInstructors: 'المدربون النشطون',
        coursesCovered: 'الدورات المغطاة',
        batchesCovered: 'الدفعات المغطاة',
        searchInstructor: 'البحث عن مدرب...',
        course: 'الدورة',
        allCourses: 'جميع الدورات',
        batch: 'الدفعة',
        allBatches: 'جميع الدفعات',
        regulation: 'النظام',
        allRegulations: 'جميع الأنظمة',
        resetFilters: 'إعادة تعيين الفلاتر',
        noInstructorsFound: 'لم يتم العثور على مدربين',
        tryAdjustingFilters: 'حاول تعديل الفلاتر أو إضافة مدرب جديد',
        instructor: 'المدرب',
        subjects: 'المواد / التخصص',
        status: 'الحالة',
        actions: 'الإجراءات',
        viewDetails: 'عرض التفاصيل',
        editInstructor: 'تعديل المدرب',
        deleteInstructor: 'حذف المدرب',
        instructorDetails: 'تفاصيل المدرب',
        teachingInformation: 'معلومات التدريس',
        activityInformation: 'معلومات النشاط',
        totalStudents: 'إجمالي الطلاب',
        joinDate: 'تاريخ الانضمام',
        lastActive: 'آخر نشاط',
        deactivate: 'إلغاء التنشيط',
        editInstructorTitle: 'تعديل المدرب',
        addNewInstructor: 'إضافة مدرب جديد',
        name: 'الاسم',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        subjectsLabel: 'المواد',
        active: 'نشط',
        inactive: 'غير نشط',
        cancel: 'إلغاء',
        saveChanges: 'حفظ التغييرات',
        addInstructorBtn: 'إضافة مدرب',
        instructorNamePlaceholder: 'أدخل اسم المدرب',
        emailAddressPlaceholder: 'أدخل عنوان البريد الإلكتروني',
        phoneNumberPlaceholder: 'أدخل رقم الهاتف',
        selectCourse: 'اختر الدورة',
        selectBatch: 'اختر الدفعة',
        selectRegulation: 'اختر النظام',
        instructorUpdated: 'تم تحديث المدرب بنجاح',
        instructorAdded: 'تم إضافة المدرب بنجاح',
        instructorDeleted: 'تم حذف المدرب بنجاح',
        fillRequiredFields: 'يرجى ملء جميع الحقول المطلوبة',
        showing: 'عرض',
        of: 'من',
        instructors: 'المدربين',
        previous: 'السابق',
        next: 'التالي'
      },
      studentManagement: {
        title: 'إدارة الطلاب',
        subtitle: 'إدارة الطلاب وتتبع الحضور والتقدم عبر الدورات',
        searchStudents: 'البحث عن الطلاب...',
        filters: 'الفلاتر',
        clearAll: 'مسح الكل',
        addStudent: 'إضافة طالب',
        totalStudents: 'إجمالي الطلاب',
        colleges: 'الكليات',
        avgAttendance: 'متوسط الحضور',
        avgProgress: 'متوسط التقدم',
        acrossAllStudents: 'عبر جميع الطلاب',
        courseCompletion: 'إكمال الدورة',
        studentsList: 'قائمة الطلاب',
        manageStudentsAndPerformance: 'إدارة الطلاب وأدائهم',
        export: 'تصدير',
        downloadExcel: 'تنزيل Excel',
        downloadPDF: 'تنزيل PDF',
        filtersLabel: 'الفلاتر:',
        filteredResult: 'نتيجة التصفية',
        students: 'الطلاب',
        totalStudentsLabel: 'إجمالي الطلاب',
        batch: 'الدفعة',
        allBatches: 'جميع الدفعات',
        runway: 'المدرج',
        allRunways: 'جميع المدارج',
        performance: 'الأداء',
        allPerformance: 'جميع الأداء',
        status: 'الحالة',
        allStatus: 'جميع الحالات',
        active: 'نشط',
        inactive: 'غير نشط',
        suspended: 'موقوف',
        excellent: 'ممتاز',
        average: 'متوسط',
        atRisk: 'عرضة للخطر',
        studentId: 'رقم الطالب',
        name: 'الاسم',
        batchName: 'اسم الدفعة',
        branch: 'الفرع',
        startYear: 'سنة البدء',
        actions: 'الإجراءات',
        viewProfile: 'عرض الملف الشخصي',
        editStudent: 'تعديل الطالب',
        activateStudent: 'تنشيط الطالب',
        suspendStudent: 'إيقاف الطالب',
        deleteStudent: 'حذف الطالب',
        attendance: 'الحضور',
        target: 'الهدف',
        completed: 'مكتمل',
        testsPassed: 'الاختبارات الناجحة',
        testsAndStatus: 'الاختبارات والحالة',
        lastActive: 'آخر نشاط',
        year: 'السنة',
        progress: 'التقدم',
        tests: 'الاختبارات',
        modules: 'الوحدات',
        overview: 'نظرة عامة',
        activity: 'النشاط',
        edit: 'تعديل',
        delete: 'حذف',
        showing: 'عرض',
        of: 'من',
        deleteStudentTitle: 'حذف الطالب؟',
        deleteStudentDescription: 'سيؤدي هذا إلى إزالة الطالب من النظام. سيتم فقدان بيانات التسجيل والتقدم.',
        cancel: 'إلغاء',
        delete: 'حذف',
        studentUpdated: 'تم تحديث الطالب بنجاح',
        studentAdded: 'تم إضافة الطالب بالرقم: {{id}}',
        studentActivated: 'تم تنشيط الطالب',
        studentSuspended: 'تم إيقاف الطالب',
        studentProgressReset: 'تم إعادة تعيين تقدم الطالب بنجاح',
        studentDeleted: 'تم حذف الطالب',
        filtersCleared: 'تم مسح الفلاتر',
        excelReportDownloaded: 'تم تنزيل تقرير Excel',
        pdfReportDownloaded: 'تم تنزيل تقرير PDF',
        lowRisk: 'خطر منخفض',
        mediumRisk: 'خطر متوسط',
        highRisk: 'خطر عالٍ',
        twoYear: 'سنتان',
        threeYear: 'ثلاث سنوات',
        fourYear: 'أربع سنوات',
        editStudentProfile: 'تعديل ملف الطالب',
        enrollNewStudent: 'تسجيل طالب جديد',
        modifyStudentCredentials: 'تعديل بيانات الطالب والسجلات الأكاديمية.',
        fillInformationToEnroll: 'املأ المعلومات أدناه لتسجيل طالب جديد في النظام.',
        studentName: 'اسم الطالب',
        fullName: 'الاسم الكامل',
        collegeBranch: 'الكلية / الفرع',
        selectCollege: 'اختر الكلية',
        selectedCourse: 'الدورة المحددة',
        selectCourse: 'اختر الدورة',
        academicYear: 'السنة الأكاديمية',
        currentStatus: 'الحالة الحالية',
        selectStatus: 'اختر الحالة',
        emailAddress: 'عنوان البريد الإلكتروني',
        phoneNumber: 'رقم الهاتف',
        attendance: 'الحضور',
        assignments: 'الواجبات',
        overallProgress: 'التقدم العام',
        updateProfile: 'تحديث الملف',
        pleaseEnterStudentName: 'يرجى إدخال اسم الطالب',
        pleaseSelectCollege: 'يرجى اختيار الكلية',
        pleaseSelectCourse: 'يرجى اختيار الدورة',
        studentProfile: 'ملف الطالب',
        completeAcademicPerformance: 'تتبع الأداء الأكاديمي والتقدم الكامل',
        performanceSummary: 'ملخص الأداء',
        monthlyAttendanceBreakdown: 'تفصيل الحضور الشهري',
        assignmentStatus: 'حالة الواجبات',
        testPerformance: 'أداء الاختبارات',
        moduleProgress: 'تقدم الوحدات',
        recentActivity: 'النشاط الأخير',
        adminActions: 'إجراءات المسؤول',
        loginFrequency: 'تكرار تسجيل الدخول',
        lastActive: 'آخر نشاط',
        assignmentSubmissions: 'تسليم الواجبات',
        testAttempts: 'محاولات الاختبار',
        present: 'حاضر',
        absent: 'غائب',
        sessions: 'جلسات',
        due: 'تاريخ الاستحقاق',
        submitted: 'تم التسليم',
        notSubmitted: 'لم يتم التسليم',
        score: 'الدرجة',
        date: 'التاريخ',
        attempts: 'المحاولات',
        year: 'السنة',
        month: 'الشهر',
        completed: 'مكتمل',
        activate: 'تنشيط',
        suspend: 'إيقاف',
        resetProgress: 'إعادة تعيين التقدم',
        noAttendanceData: 'لا توجد بيانات حضور متاحة',
        noAssignmentData: 'لا توجد بيانات واجبات متاحة',
        noTestData: 'لا توجد بيانات اختبار متاحة',
        noModuleData: 'لا توجد بيانات وحدات متاحة',
        noActivityData: 'لا توجد بيانات نشاط متاحة'
      },
      scheduleManagement: {
        title: 'إدارة الجداول الزمنية',
        subtitle: 'المسار الأكاديمي',
        breadcrumb: 'مركز الجداول',
        addSchedule: 'إضافة جدول زمني',
        academicCalendar: 'التقويم الأكاديمي',
        searchSchedules: 'البحث في الجداول الزمنية...',
        allRunways: 'جميع المدارج',
        allBatches: 'جميع الدفعات',
        selectRunwayFirst: 'اختر المدرج أولاً',
        allBatchesText: 'جميع الدفعات',
        list: 'قائمة',
        calendar: 'تقويم',
        noSchedulesFound: 'لم يتم العثور على جداول زمنية',
        tryAdjustingFilters: 'حاول تعديل البحث أو الفلاتر، أو أنشئ جدولاً جديداً.',
        createFirstSchedule: 'إنشاء أول جدول زمني',
        upcoming: 'قادم',
        liveNow: 'مباشر الآن',
        completed: 'مكتمل',
        editSession: 'تعديل الجلسة',
        deleteTask: 'حذف المهمة',
        launch: 'إطلاق',
        instructor: 'المدرب',
        batch: 'الدفعة',
        mode: 'الوضع',
        scheduleSession: 'جلسة مجدولة',
        clickToEdit: 'انقر للتعديل',
        clickToSeeAll: 'انقر لعرض الكل',
        more: 'أكثر',
        editSchedule: 'تعديل الجدول الزمني',
        addNewSchedule: 'إضافة جدول زمني جديد',
        updateSchedule: 'تحديث الجدول الزمني',
        newScheduleCreated: 'تم إنشاء جدول زمني جديد',
        scheduleUpdated: 'تم تحديث الجدول الزمني',
        scheduleDeleted: 'تم حذف الجدول الزمني',
        areYouSureDelete: 'هل أنت متأكد من حذف هذا الجدول الزمني؟',
        pleaseFillRequiredFields: 'يرجى ملء جميع الحقول المطلوبة',
        runway: 'المدرج',
        batchLabel: 'الدفعة',
        date: 'التاريخ',
        time: 'الوقت',
        sessionTitle: 'عنوان الجلسة',
        description: 'الوصف',
        instructorLabel: 'المدرب',
        roomLocation: 'الغرفة/الموقع',
        meetingRoom: 'غرفة الاجتماع',
        meetingLink: 'رابط الاجتماع',
        online: 'عبر الإنترنت',
        offline: 'شخصي',
        selectRunway: 'اختر المدرج',
        selectBatch: 'اختر الدفعة',
        selectInstructor: 'اختر المدرب',
        updateScheduleDetails: 'تحديث تفاصيل الجدول الزمني أدناه',
        fillInformationToCreate: 'املأ التفاصيل لإنشاء جدول زمني جديد',
        cancel: 'إلغاء',
        createSchedule: 'إنشاء جدول زمني'
      },
      assessmentManagement: {
        assignment: 'التقييمات',
        subtitle: 'إدارة ومتابعة مهام الطلاب عبر الدفعات',
        createAssessment: 'إنشاء تقييم',
        totalActive: 'إجمالي النشط',
        published: 'منشور',
        upcomingDeadlines: 'المواعيد النهائية القادمة',
        totalSubmissions: 'إجمالي عمليات التقديم',
        searchAssessment: 'البحث في عنوان التقييم...',
        runway: 'المدرج',
        batch: 'الدفعة',
        status: 'الحالة',
        allRunways: 'جميع المدارج',
        allBatches: 'جميع الدفعات',
        allStatus: 'جميع الحالات',
        draft: 'مسودة',
        closed: 'مغلق',
        title: 'العنوان',
        instructor: 'المدرب',
        deadline: 'الموعد النهائي',
        submissions: 'عمليات التقديم',
        actions: 'الإجراءات',
        viewDetails: 'عرض التفاصيل',
        editAssessment: 'تعديل التقييم',
        viewSubmissions: 'عرض عمليات التقديم',
        delete: 'حذف',
        noAssessmentsMatch: 'لا توجد تقييمات تطابق معاييرك',
        showingAssessments: 'عرض {{count}} تقييمات',
        previous: 'السابق',
        next: 'التالي',
        backToAssessments: 'العودة إلى التقييمات',
        submissionOverview: 'نظرة عامة على عمليات التقديم وأداء الطلاب',
        exportCSV: 'تصدير CSV',
        contactPending: 'اتصال معلق',
        avgEvaluationTAT: 'متوسط وقت التقييم',
        turnaroundTime: 'وقت الاستجابة',
        submissionRate: 'معدل التقديم',
        evaluationProgress: 'تقدم التقييم',
        assignedInstructors: 'المدربون المعينون',
        active: 'نشط',
        studentSubmissions: 'عمليات تقديم الطلاب',
        realTimeTracking: 'تتبع في الوقت الفعلي لتقدم التقييم',
        searchStudent: 'البحث عن طالب...',
        selectBatch: 'اختر الدفعة',
        noStudentsFound: 'لم يتم العثور على طلاب يطابقون الفلاتر الخاصة بك.',
        showingStudents: 'عرض {{current}} من {{total}} طالب',
        page: 'صفحة {{current}} من {{total}}',
        submissionContent: 'محتوى التقديم',
        repositoryURL: 'رابط المستودع',
        liveDemo: 'عرض توضيحي مباشر',
        studentNotes: 'ملاحظات الطالب',
        noAdditionalNotes: 'لم يتم توفير ملاحظات إضافية من الطالب.',
        evaluationStatus: 'حالة التقييم',
        currentStatus: 'الحالة الحالية',
        evaluated: 'تم تقييمه',
        submitted: 'تم تقديمه',
        pending: 'معلق',
        finalGrade: 'الدرجة النهائية',
        gradeAssessment: 'تقييم التقييم',
        student: 'الطالب',
        submission: 'التقديم',
        reviewTAT: 'وقت المراجعة',
        marks: 'الدرجات',
        quickView: 'عرض سريع',
        evaluate: 'تقييم',
        viewSubmissionHistory: 'عرض سجل التقديم',
        downloadAllFiles: 'تنزيل جميع الملفات',
        resetSubmission: 'إعادة تعيين التقديم',
        noSubmission: 'لا يوجد تقديم'
      },
      assessmentForm: {
        backToAssessments: 'العودة إلى التقييمات',
        editAssessment: 'تعديل التقييم',
        createAssessment: 'إنشاء تقييم',
        updating: 'تحديث: {{id}}',
        designNewTask: 'تصميم مهمة جديدة للطلاب لإكمالها',
        saveDraft: 'حفظ المسودة',
        publish: 'نشر',
        basicInformation: 'المعلومات الأساسية',
        assessmentTitle: 'عنوان التقييم',
        titlePlaceholder: 'مثال: بناء واجهة برمجة المصادقة',
        description: 'الوصف',
        descriptionPlaceholder: 'نظرة عامة موجزة عن التقييم...',
        descriptionHelp: 'لخص ما سيتعلمه الطالب من هذه المهمة.',
        detailedInstructions: 'تعليمات مفصلة',
        instructionsPlaceholder: 'تعليمات خطوة بخطوة للطالب...',
        attachments: 'المرفقات',
        uploadText: 'انقر للرفع أو اسحب وأفلت',
        uploadHelp: 'PDF، DOCX، ZIP (الحد الأقصى 10 ميجابايت)',
        evaluationGrading: 'التقييم والتقدير',
        maxMarks: 'الدرجة القصوى',
        passingMarks: 'درجة النجاح',
        evaluationRubric: 'معايير التقييم',
        addCriteria: 'إضافة معيار',
        rubricPlaceholder: 'حدد معايير التقييم (مثال: جودة الكود، الوظائف...)',
        academicDetails: 'التفاصيل الأكاديمية',
        runway: 'المدرج',
        selectRunway: 'اختر المدرج',
        batchSubBatch: 'الدفعة / الدفعة الفرعية',
        selectBatch: 'اختر الدفعة',
        deadline: 'الموعد النهائي',
        assignInstructor: 'تعيين مدرب',
        selectInstructor: 'اختر المدرب',
        instructorHelp: 'المدرب المعين سيكون مسؤولاً عن تقييم جميع عمليات تقديم الطلاب لهذا التقييم.',
        publicationStatus: 'حالة النشر',
        neverPublished: 'لم يتم نشره أبداً',
        newAssessment: 'تقييم جديد',
        publishWarning: 'نشر هذا التقييم سيقوم فوراً بإبلاغ جميع الطلاب في الدفعات المحددة.'
      },
      assignmentForm: {
        backToDashboard: 'العودة إلى لوحة التحكم',
        cancel: 'إلغاء',
        saving: 'جاري الحفظ...',
        updateAssignment: 'تحديث الواجب',
        createAssignment: 'إنشاء واجب',
        editAssignment: 'تعديل الواجب',
        newAssignment: 'واجب جديد',
        draft: 'مسودة',
        setupParameters: 'إعداد معلمات الواجب ومعايير التقييم.',
        generalInformation: 'المعلومات العامة',
        assignmentTitle: 'عنوان الواجب',
        titlePlaceholder: 'مثال: أنماط React المتقدمة',
        category: 'الفئة',
        categoryPlaceholder: 'مثال: تطوير الواجهة الأمامية',
        assignmentType: 'نوع الواجب',
        selectType: 'اختر النوع',
        standardSubmission: 'تقديم قياسي',
        codeRepository: 'مستودع الكود',
        interactiveQuiz: 'اختبار تفاعلي',
        description: 'الوصف',
        descriptionPlaceholder: 'قدم تعليمات مفصلة للطلاب...',
        academicContext: 'السياق الأكاديمي',
        targetRunway: 'المدرج المستهدف',
        selectRunway: 'اختر المدرج',
        targetBatch: 'الدفعة المستهدفة',
        selectBatch: 'اختر الدفعة',
        selectRunwayFirst: 'اختر المدرج أولاً',
        submissionEvaluation: 'التقديم والتقييم',
        dueDateTime: 'تاريخ ووقت الاستحقاق',
        totalMarks: 'الدرجات الإجمالية',
        scoringRubrics: 'معايير التقييم',
        addCriterion: 'إضافة معيار',
        rubricInfo: 'إعداد معايير للتقييم المنظم. يجب أن تتطابق مجموع نقاط المعايير بشكل مثالي مع الدرجات الإجمالية.',
        criterionPlaceholder: 'المعيار {{index}} (مثال: بنية الكود)',
        max: 'الحد الأقصى',
        totalRubricWeight: 'وزن المعايير الإجمالي',
        saveChanges: 'حفظ التغييرات',
        publishAssignment: 'نشر الواجب',
        assignmentNotFound: 'الواجب غير موجود',
        assignmentCreated: 'تم إنشاء الواجب بنجاح',
        assignmentUpdated: 'تم تحديث الواجب بنجاح'
      },
      questionManager: {
        contentManagement: 'إدارة المحتوى',
        assignmentId: 'معرف الواجب: {{id}}',
        addQuestion: 'إضافة سؤال',
        questions: 'الأسئلة',
        totalMarks: 'الدرجات الإجمالية',
        estimatedTime: 'الوقت المقدر',
        options: 'الخيارات',
        tfOptions: 'خيارات ص/خطأ',
        programming: 'البرمجة',
        writeAnswer: 'كتابة الإجابة',
        keySet: 'مجموعة المفاتيح',
        edit: 'تعديل',
        duplicate: 'تكرار',
        delete: 'حذف',
        addQuestionToSet: 'إضافة سؤال للمجموعة'
      },
      distributionPage: {
        manageDistribution: 'إدارة التوزيع',
        assignmentId: 'معرف الواجب: {{id}}',
        applySyncDistribution: 'تطبيق ومزامنة التوزيع',
        targetRunways: '1. المدارج المستهدفة',
        targetBatches: '2. الدفعات المستهدفة',
        selectAll: 'اختر الكل',
        filterBatches: 'تصفية الدفعات...',
        students: 'الطلاب',
        viewStudents: 'عرض الطلاب',
        availabilityControls: '3. عناصر التحكم في التوفر',
        startDateTime: 'تاريخ ووقت البدء',
        endDateTime: 'تاريخ ووقت الانتهاء',
        keepOpen: 'إبقاء مفتوح (بدون موعد نهائي)',
        liveStatus: 'حالة البث المباشر',
        eligibilityEngine: 'محرك الأهلية',
        studentsWillReceive: 'سيحصل الطلاب على الوصول الفوري.',
        runways: 'المدارج',
        batches: 'الدفعات',
        conflictCheck: 'فحص التعارض',
        clean: 'نظيف',
        selected: 'محدد',
        confirmDistribution: 'تأكيد التوزيع'
      },
      attendance: {
        markAttendance: 'تسجيل الحضور',
        efficiencyMarking: 'أدوات تسجيل فعالة للدفعات الكبيرة في المدرج.',
        attendanceHistory: 'سجل الحضور',
        report: 'تقرير',
        runway: 'المدرج',
        year: 'السنة',
        batch: 'الدفعة',
        date: 'التاريخ',
        searchByNameBatch: 'البحث بالاسم أو الدفعة...',
        studentList: 'قائمة الطلاب',
        markAllPresent: 'تسجيل الكل حاضر',
        markAllAbsent: 'تسجيل الكل غائب',
        markAll: 'تم تسجيل الكل كـ {{status}}',
        attendanceReset: 'تم إعادة تعيين الحضور',
        attendanceSummary: 'ملخص الحضور',
        attendanceRate: 'معدل الحضور',
        total: 'الإجمالي',
        present: 'حاضر',
        absent: 'غائب',
        marked: 'مسجل: {{count}}',
        remaining: 'متبقي: {{count}}',
        saveAsDraft: 'حفظ كمسودة',
        saveAttendance: 'حفظ الحضور',
        attendanceRecorded: 'تم تسجيل الحضور بنجاح!',
        markAllStudents: 'يرجى تسجيل الحضور لجميع {{count}} طلاب.',
        noStudentsFound: 'لم يتم العثور على طلاب لهذه الدفعة.',
        markedOfTotal: 'تم تسجيل {{marked}} من {{total}} طالب',
        presentStatus: 'حاضر',
        absentStatus: 'غائب'
      },
      attendanceHistory: {
        attendanceHistory: 'سجل الحضور',
        backToMarking: 'العودة إلى التسجيل',
        goBack: 'العودة',
        allYears: 'جميع السنوات',
        customRange: 'نطاق مخصص',
        viewYearly: 'عرض سنوي',
        exportData: 'تصدير البيانات',
        searchHistory: 'البحث في السجل...',
        allBatches: 'جميع الدفعات',
        yearlyAttendance: 'الحضور السنوي',
        monthsInYear: 'الأشهر في {{year}}',
        dailySessions: 'الجلسات اليومية',
        customRangeSearch: 'بحث النطاق المخصص',
        records: 'السجلات',
        title: 'العنوان',
        sessions: 'الجلسات',
        avgTotalPresent: 'المتوسط/الإجمالي الحاضر',
        avgTotalAbsent: 'المتوسط/الإجمالي الغائب',
        status: 'الحالة',
        view: 'عرض',
        fullAcademicYear: 'السنة الأكاديمية الكاملة {{year}}',
        monthlyConsolidated: 'موحد شهرياً',
        recordedOn: 'سجل في {{date}}',
        days: 'أيام',
        noHistoryFound: 'لم يتم العثور على سجل',
        expandSearch: 'وسع نطاق البحث أو تحقق من فترة أخرى.',
        customRangeLabel: 'نطاق مخصص'
      },
      adminPanel: {
        adminPanel: 'لوحة الإدارة',
        comprehensiveManagement: 'إدارة المنصة الشاملة',
        overview: 'نظرة عامة',
        users: 'المستخدمون',
        courses: 'الدورات',
        jobs: 'الوظائف',
        analytics: 'التحليلات',
        logs: 'سجل الأنشطة',
        settings: 'الإعدادات',
        totalUsers: 'إجمالي المستخدمين',
        totalCourses: 'إجمالي الدورات',
        activeJobs: 'الوظائف النشطة',
        revenue: 'الإيرادات',
        inLast7Days: '+{{count}} في آخر 7 أيام',
        published: '{{count}} منشورة',
        applications: '{{count}} طلب',
        fromLastMonth: '+{{count}}% من الشهر الماضي',
        userDistributionByRole: 'توزيع المستخدمين حسب الدور',
        students: 'الطلاب',
        instructors: 'المدرسون',
        admins: 'المسؤولون',
        quickActions: 'إجراءات سريعة',
        manageUsers: 'إدارة المستخدمين',
        manageCourses: 'إدارة الدورات',
        manageJobs: 'إدارة الوظائف',
        failedToFetchDashboard: 'فشل في جلب بيانات لوحة القيادة'
      },
      superAdminInstitutes: {
        instituteManagement: 'إدارة المعاهد',
        manageAllInstitutes: 'إدارة جميع المعاهد',
        createInstitute: 'إنشاء معهد',
        total: 'الإجمالي',
        active: 'نشط',
        pending: 'في الانتظار',
        suspended: 'معلق',
        allInstitutes: 'جميع المعاهد',
        plans: 'الخطط',
        search: 'بحث...',
        allStatus: 'جميع الحالات',
        loading: 'جاري التحميل...',
        noInstitutes: 'لا توجد معاهد',
        noPendingRequests: 'لا توجد طلبات معلقة',
        view: 'عرض',
        activate: 'تفعيل',
        suspend: 'تعليق',
        delete: 'حذف',
        approve: 'موافقة',
        reject: 'رفض',
        create: 'إنشاء',
        cancel: 'إلغاء',
        unlimited: 'غير محدود',
        students: 'الطلاب',
        courses: 'الدورات',
        storage: 'التخزين',
        slug: 'الرابط',
        email: 'البريد الإلكتروني',
        description: 'الوصف',
        city: 'المدينة',
        country: 'البلد',
        name: 'الاسم',
        status: 'الحالة',
        users: 'المستخدمون',
        approveRequest: 'موافقة على الطلب؟',
        rejectRequest: 'رفض الطلب؟',
        reason: 'السبب...',
        instituteCreated: 'تم إنشاء المعهد',
        activated: 'تم التفعيل',
        suspended: 'تم التعليق',
        deleted: 'تم الحذف',
        approved: 'تمت الموافقة!',
        rejected: 'مرفوض',
        failedToLoadData: 'فشل في تحميل البيانات',
        failed: 'فشل',
        deleteConfirm: 'حذف؟',
        failedToLoadDetails: 'فشل في تحميل التفاصيل'
      },
      userManagement: {
        userManagement: 'إدارة المستخدمين',
        managePlatformUsers: 'إدارة مستخدمي المنصة والأدوار',
        addUser: 'إضافة مستخدم',
        searchUsers: 'البحث عن المستخدمين بالبريد الإلكتروني أو الاسم...',
        id: 'المعرف',
        email: 'البريد الإلكتروني',
        name: 'الاسم',
        role: 'الدور',
        joined: 'انضم',
        student: 'طالب',
        instructor: 'مدرب',
        admin: 'مدير',
        editUser: 'تعديل المستخدم',
        createNewUser: 'إنشاء مستخدم جديد',
        updateUser: 'تحديث معلومات المستخدم',
        addNewUser: 'إضافة مستخدم جديد إلى المنصة',
        fullName: 'الاسم الكامل',
        password: 'كلمة المرور',
        leaveEmptyToKeepCurrent: '(اتركه فارغاً للاحتفاظ بالحالي)',
        deleteUser: 'حذف المستخدم',
        userDeletedSuccessfully: 'تم حذف المستخدم بنجاح',
        userCreatedSuccessfully: 'تم إنشاء المستخدم بنجاح',
        userUpdatedSuccessfully: 'تم تحديث المستخدم بنجاح',
        roleUpdatedSuccessfully: 'تم تحديث الدور بنجاح',
        failedToFetchUsers: 'فشل في جلب المستخدمين',
        failedToDeleteUser: 'فشل في حذف المستخدم',
        failedToUpdateRole: 'فشل في تحديث الدور',
        operationFailed: 'فشلت العملية',
        deleteUserConfirm: 'حذف المستخدم {{email}}؟',
        update: 'تحديث',
        create: 'إنشاء',
        cancel: 'إلغاء'
      },
      jobManagement: {
        jobManagement: 'إدارة الوظائف',
        manageJobs: 'إدارة الوظائف المنشورة والطلبات',
        addJob: 'إضافة وظيفة',
        searchJobs: 'البحث في الوظائف...',
        id: 'المعرف',
        jobTitle: 'عنوان الوظيفة',
        location: 'الموقع',
        type: 'النوع',
        salary: 'الراتب',
        remote: 'عن بعد',
        notSpecified: 'غير محدد',
        editJob: 'تعديل الوظيفة',
        createNewJob: 'إنشاء وظيفة جديدة',
        updateJob: 'تحديث الوظيفة المنشورة',
        addNewJob: 'إضافة وظيفة جديدة منشورة',
        company: 'الشركة',
        jobType: 'نوع الوظيفة',
        fullTime: 'دوام كامل',
        partTime: 'دوام جزئي',
        contract: 'عقد',
        internship: 'تدريب',
        salaryRange: 'نطاق الراتب',
        description: 'الوصف',
        requirements: 'المتطلبات',
        listRequirements: 'قائمة المتطلبات (واحد في كل سطر)',
        deleteJob: 'حذف الوظيفة',
        jobDeletedSuccessfully: 'تم حذف الوظيفة بنجاح',
        jobCreatedSuccessfully: 'تم إنشاء الوظيفة بنجاح',
        jobUpdatedSuccessfully: 'تم تحديث الوظيفة بنجاح',
        failedToFetchJobs: 'فشل في جلب الوظائف',
        failedToDeleteJob: 'فشل في حذف الوظيفة',
        operationFailed: 'فشلت العملية',
        deleteJobConfirm: 'حذف الوظيفة "{{title}}"؟',
        update: 'تحديث',
        create: 'إنشاء',
        cancel: 'إلغاء'
      },
      analyticsDashboard: {
        analyticsDashboard: 'لوحة التحليلات',
        platformPerformance: 'أداء المنصة ورؤى',
        revenue: 'الإيرادات',
        users: 'المستخدمون',
        courses: 'الدورات',
        engagement: 'المشاركة',
        revenueOverview: 'نظرة عامة على الإيرادات',
        last7Days: 'آخر 7 أيام',
        last30Days: 'آخر 30 يوم',
        lastQuarter: 'الربع الأخير',
        lastYear: 'العام الماضي',
        totalRevenue: 'إجمالي الإيرادات',
        transactions: 'المعاملات',
        avgTransaction: 'متوسط المعاملة',
        perTransaction: 'لكل معاملة',
        acrossAllPaymentMethods: 'عبر جميع طرق الدفع',
        fromLastPeriod: '+{{count}}% من الفترة السابقة',
        revenueTrend: 'اتجاه الإيرادات',
        chartVisualization: 'سيتم عرض التخطيط البياني هنا (دمج Chart.js أو Recharts)',
        userAnalytics: 'تحليلات المستخدمين',
        userGrowth: 'نمو المستخدمين',
        userActivity: 'نشاط المستخدمين',
        userGrowthChart: 'سيتم عرض مخطط نمو المستخدمين هنا',
        activityHeatmap: 'سيتم عرض خريطة النشاط هنا',
        courseAnalytics: 'تحليلات الدورات',
        mostPopularCourses: 'الدورات الأكثر شعبية',
        coursePopularityChart: 'سيتم عرض مخطط شعبية الدورات هنا',
        platformEngagement: 'مشاركة المنصة',
        dailyActiveUsers: 'المستخدمون النشطون يومياً',
        sessionDuration: 'مدة الجلسة',
        dauChart: 'سيتم عرض مخطط DAU هنا',
        sessionDurationChart: 'سيتم عرض مخطط مدة الجلسة هنا',
        failedToFetchRevenueData: 'فشل في جلب بيانات الإيرادات'
      },
      activityLogs: {
        activityLogs: 'سجلات النشاط',
        trackSystemActivities: 'تتبع أنشطة النظام والتغييرات',
        noActivityLogsFound: 'لم يتم العثور على سجلات نشاط',
        create: 'إنشاء',
        update: 'تحديث',
        delete: 'حذف',
        user: 'مستخدم',
        failedToFetchActivityLogs: 'فشل في جلب سجلات النشاط'
      },
      systemSettings: {
        systemSettings: 'إعدادات النظام',
        configurePlatform: 'تكوين إعدادات المنصة',
        saveChanges: 'حفظ التغييرات',
        saving: 'جاري الحفظ...',
        general: 'عام',
        security: 'الأمان',
        email: 'البريد الإلكتروني',
        advanced: 'متقدم',
        siteName: 'اسم الموقع',
        siteDescription: 'وصف الموقع',
        supportEmail: 'بريد الدعم',
        maxUploadSize: 'حجم التحميل الأقصى (ميجابايت)',
        enableUserRegistrations: 'تمكين تسجيل المستخدمين',
        allowNewUsersToRegister: 'السماح للمستخدمين الجدد بالتسجيل في المنصة',
        requireEmailVerification: 'مطالبة بالتحقق من البريد الإلكتروني',
        usersMustVerifyEmail: 'يجب على المستخدمين التحقق من بريدهم الإلكتروني قبل الوصول إلى المنصة',
        enableTwoFactor: 'تمكين المصادقة الثنائية',
        allowUsersToEnable2FA: 'السماح للمستخدمين بتمكين المصادقة الثنائية لحساباتهم',
        sessionTimeout: 'مهلة الجلسة (بالدقائق)',
        emailSettingsConfigured: 'يتم تكوين إعدادات البريد الإلكتروني عبر متغيرات البيئة (خادم SMTP، بيانات الاعتماد، إلخ)',
        requiredEnvironmentVariables: 'متغيرات البيئة المطلوبة:',
        maintenanceMode: 'وضع الصيانة',
        maintenanceWarning: '⚠️ سيجعل هذا المنصة غير متاحة لجميع المستخدمين باستثناء المديرين',
        databaseBackup: 'نسخة احتياطية لقاعدة البيانات',
        downloadDatabaseBackup: 'تنزيل نسخة احتياطية لقاعدة البيانات',
        clearCache: 'مسح التخزين المؤقت',
        clearSystemCache: 'مسح التخزين المؤقت للنظام',
        settingsSavedSuccessfully: 'تم حفظ الإعدادات بنجاح',
        failedToFetchSettings: 'فشل في جلب إعدادات النظام',
        failedToSaveSettings: 'فشل في حفظ الإعدادات'
      },
      profile: {
        profile: 'الملف الشخصي',
        memberSince: 'عضو منذ {{year}}',
        totalPoints: 'إجمالي النقاط',
        currentStreak: 'السلسلة الحالية',
        globalRank: 'الترتيب العالمي',
        enrolledCourses: 'الدورات المسجلة',
        keepLearning: 'استمر في التعلم!',
        dontBreakIt: 'لا تقطعها!',
        topPerformer: 'أداء ممتاز!',
        activeLearning: 'تعلم نشط',
        achievements: 'الإنجازات',
        firstCourse: 'الدورة الأولى',
        enrolledInFirstCourse: 'سجلت في أول دورة',
        weekWarrior: 'محارب الأسبوع',
        sevenDayStreak: 'سلسلة تعلم 7 أيام',
        courseCompleter: 'مكمل الدورات',
        completeFirstCourse: 'أكمل أول دورة',
        failedToFetchStats: 'فشل في جلب الإحصائيات'
      },
      settings: {
        settings: 'الإعدادات',
        managePreferences: 'إدارة تفضيلاتك',
        appearance: 'المظهر',
        customizeAppLook: 'تخصيص مظهر التطبيق',
        darkMode: 'الوضع الليلي',
        enableDarkTheme: 'تمكين السمة الداكنة',
        language: 'اللغة',
        choosePreferredLanguage: 'اختر لغتك المفضلة',
        notifications: 'الإشعارات',
        manageNotificationPreferences: 'إدارة تفضيلات الإشعارات',
        emailNotifications: 'إشعارات البريد الإلكتروني',
        pushNotifications: 'الإشعارات الفورية',
        courseUpdates: 'تحديثات الدورات'
      },
      sidebar: {
        courseManagement: 'إدارة الدورات',
        batchManagement: 'إدارة البرامج',
        instructorManagement: 'إدارة المدربين',
        studentManagement: 'إدارة الطلاب',
        scheduleManagement: 'إدارة الجدول',
        assessments: 'التقييمات',
        assignmentManagement: 'إدارة الواجبات',
        markAttendance: 'تسجيل الحضور',
        attendanceHistory: 'سجل الحضور',
        institutes: 'المعاهد',
        instituteAnalytics: 'تحليلات المعهد',
        branding: 'العلامة التجارية',
        instructorDashboard: 'لوحة تحكم المدرب',
        batchSchedule: 'جدول الدفعات',
        assessmentsManagement: 'إدارة التقييمات',
        managePanel: 'لوحة الإدارة',
        liveClasses: 'الفصول المباشرة',
        testsQuiz: 'الاختبارات/الاختبارات القصيرة',
        assignments: 'الواجبات',
        bookmarks: 'الإشارات المرجعية',
        codeLab: 'مختبر البرمجة',
        darkMode: 'الوضع الليلي',
        lightMode: 'الوضع النهاري',
        logout: 'تسجيل الخروج',
        superAdmin: 'سوبر أدمن',
        payments: 'المدفوعات',
        paymentHistory: 'سجل المدفوعات',
        paymentManagement: 'إدارة المدفوعات',
        studentPaymentSupport: 'دعم دفعات الطلاب'
      },
      assignmentManagement: {
        title: 'بوابة الواجبات',
        subtitle: 'إنشاء وتوزيع وإدارة التقييمات العالمية للطلاب.',
        control: 'التحكم في الواجبات',
        createAssignment: 'إنشاء واجب',
        totalAssignments: 'إجمالي الواجبات',
        reachingStudents: 'الطلاب المستهدفون',
        liveSubmissions: 'التقديمات المباشرة',
        pendingReviews: 'المراجعات المعلقة',
        searchAssignments: 'البحث في الواجبات...',
        allSubjects: 'جميع المواد',
        allRunways: 'جميع المدرجات',
        programming: 'البرمجة',
        aptitude: 'الاستعداد',
        mathematics: 'الرياضيات',
        assignmentDetails: 'تفاصيل الواجب',
        distribution: 'التوزيع',
        marksTime: 'الدرجات/الوقت',
        status: 'الحالة',
        actions: 'الإجراءات',
        batches: 'الدفاعات',
        marks: 'الدرجات',
        mins: 'دقائق',
        live: 'مباشر',
        draft: 'مسودة',
        questions: 'الأسئلة',
        view: 'عرض',
        edit: 'تعديل',
        delete: 'حذف',
        createNewAssignment: 'إنشاء واجب جديد',
        step1BasicInfo: 'الخطوة 1: المعلومات الأساسية',
        cancel: 'إلغاء',
        saveContinue: 'حفظ ومتابعة',
        assignmentTitle: 'عنوان الواجب',
        titlePlaceholder: 'مثال: إتقان أنماط React المتقدمة',
        subject: 'المادة',
        targetLevel: 'المستوى المستهدف',
        totalMarks: 'الدرجات الإجمالية',
        difficulty: 'الصعوبة',
        beginner: 'مبتدئ',
        intermediate: 'متوسط',
        advanced: 'متقدم',
        assignmentDescription: 'وصف الواجب',
        descriptionPlaceholder: 'اشرح أهداف ومتطلبات هذا الواجب...',
        tagsKeywords: 'العلامات والكلمات المفتاحية',
        separateByCommas: 'افصل بينها بفواصل',
        tagsPlaceholder: 'react، frontend، hooks، level-3',
        whatHappensNext: 'ماذا يحدث بعد ذلك؟',
        nextStepInfo: 'بعد حفظ هذه المعلومات، سيتم توجيهك إلى **مدير الأسئلة** حيث يمكنك البدء في إضافة أسئلة لهذا الواجب.'
      }
    }
  },
  hi: {
    translation: {
      welcome: 'स्वागत है',
      dashboard: 'डैशबोर्ड',
      courses: 'पाठ्यक्रम',
      myCourses: 'मेरे पाठ्यक्रम',
      leaderboard: 'लीडरबोर्ड',
      tests: 'परीक्षण और मूल्यांकन',
      assignments: 'असाइनमेंट',
      companyQuestions: 'कंपनी प्रश्न',
      jobs: 'नौकरियां और इंटर्नशिप',
      bookmarks: 'बुकमार्क',
      profile: 'प्रोफ़ाइल',
      chat: 'चैट',
      notifications: 'सूचनाएं',
      settings: 'सेटिंग्स',
      logout: 'लॉग आउट',
      payments: 'भुगतानें',
      paymentManagement: 'भुगतान प्रबंधन',
      paymentHistory: 'भुगतान इतिहास',
      makePayment: 'भुगतान करें',
      paymentSummary: 'भुगतान सारांश',
      offlinePayment: 'ऑफलाइन भुगतान',
      onlinePayment: 'ऑनलाइन भुगतान',
      paymentStatus: 'भुगतान स्थिति',
      transactionId: 'लेनदेन आईडी',
      receipt: 'रसीद',
      balance: 'शेष',
      paidAmount: 'भुगतान की राशि',
      totalCost: 'कुल लागत',
      runwayPayment: 'रनवे भुगतान',
      selectRunways: 'रनवे चुनें',
      paymentDetails: 'भुगतान विवरण',
      addOfflinePayment: 'ऑफलाइन भुगतान जोड़ें',
      paymentAnalytics: 'भुगतान एनालिटिक्स',
      totalPayments: 'कुल भुगतान',
      successfulPayments: 'सफल भुगतान',
      pendingPayments: 'लंबित भुगतान',
      collectPayment: 'भुगतान एकत्रित करें',
      studentPaymentSupport: 'छात्र भुगतान समर्थन',
      paymentCollection: 'भुगतान संग्रह',
      batchStudents: 'बैच छात्र',
      batchRunways: 'बैच रनवे',
      selectBatch: 'बैच चुनें',
      selectStudent: 'छात्र चुनें',
      processOfflinePayment: 'ऑफलाइन भुगतान प्रोसेस करें',
      paymentInitiated: 'भुगतान शुरू किया गया',
      paymentConfirmed: 'भुगतान की पुष्टि',
      paymentFailed: 'भुगतान विफल',
      paymentReceipt: 'भुगतान रसीद',
      receiptNumber: 'रसीद नंबर',
      payerName: 'भुगतानकर्ता का नाम',
      paymentMode: 'भुगतान मोड',
      paymentRemarks: 'भुगतान टिप्पणियां',
      itemsSelected: 'चुनी गई वस्तुएं',
      currentPaymentSummary: 'वर्तमान भुगतान सारांश',
      paymentProgress: 'भुगतान प्रगति',
      payNow: 'अभी भुगतान करें',
      downloadReceipt: 'रसीद डाउनलोड करें',
      viewReceipt: 'रसीद देखें',
      paymentComplete: 'भुगतान पूर्ण',
      paymentPending: 'भुगतान लंबित',
      login: 'लॉगिन',
      register: 'रजिस्टर',
      email: 'ईमेल',
      password: 'पासवर्ड',
      fullName: 'पूरा नाम',
      submit: 'जमा करें',
      cancel: 'रद्द करें',
      save: 'सहेजें',
      delete: 'हटाएं',
      edit: 'संपादित करें',
      view: 'देखें',
      enrollNow: 'अभी नामांकन करें',
      startLearning: 'सीखना शुरू करें',
      continueLearning: 'सीखना जारी रखें',
      completed: 'पूर्ण',
      inProgress: 'प्रगति में',
      notStarted: 'शुरू नहीं हुआ',
      streak: 'स्ट्रीक',
      points: 'अंक',
      rank: 'रैंक',
      totalLessons: 'कुल पाठ',
      completedLessons: 'पूर्ण पाठ',
      collegeManagement: {
        title: 'कोर्स प्रबंधन',
        subtitle: 'ऑनलाइन कोचिंग - रनवे (R1/R2/R3) के अनुसार कोर्स, प्रत्येक रनवे के लिए अलग पाठ्यक्रम, शनिवार और रविवार कक्षाएं',
        editCollege: 'कॉलेज संपादित करें',
        batches: 'बैच',
        students: 'छात्र',
        contactAndLocation: 'संपर्क और स्थान',
        totalStudents: 'कुल छात्र',
        activeBatches: 'सक्रिय बैच',
        academicPaths: 'शैक्षणिक पथ',
        yearStarted: 'शुरुआती वर्ष',
        managementPathAndCurriculum: 'प्रबंधन पथ और पाठ्यक्रम',
        managementPathDescription: 'शैक्षणिक पथ, प्रवेश स्तर और पाठ्यक्रम संसाधन प्रबंधित करें',
        addPath: 'पथ जोड़ें',
        satSunClasses: 'शनि और रवि कक्षाएं',
        download: 'डाउनलोड',
        noManagementPaths: 'अभी तक कोई प्रबंधन पथ नहीं बनाया गया है।',
        createFirstPath: 'पहला पथ बनाएं',
        noCollegeRegistered: 'कोई कॉलेज पंजीकृत नहीं है। शुरू करने के लिए कॉलेज जोड़ें।',
        editCollegeDescription: 'कॉलेज विवरण और संपर्क जानकारी अपडेट करें।',
        collegeName: 'कॉलेज का नाम',
        location: 'स्थान',
        contactDetails: 'संपर्क विवरण',
        updateCollege: 'कॉलेज अपडेट करें',
        editManagementPath: 'प्रबंधन पथ संपादित करें',
        createManagementPath: 'प्रबंधन पथ बनाएं',
        definePathDetails: 'इस पथ के लिए विवरण, रनवे और अवधि निर्धारित करें।',
        pathName: 'पथ का नाम',
        applicableRunway: 'लागू रनवे',
        selectRunway: 'रनवे चुनें',
        batchLabel: 'बैच लेबल',
        pathDuration: 'पथ अवधि',
        description: 'विवरण',
        updatePath: 'पथ अपडेट करें',
        createPath: 'पथ बनाएं',
        defaultPathDescription: 'लचीले प्रवेश बिंदुओं के साथ व्यापक पाठ्यक्रम।',
        deleteConfirmTitle: 'पथ हटाएं?',
        deleteConfirmText: 'इस क्रिया को पूर्ववत नहीं किया जा सकता।',
        loadingPaths: 'पथ लोड हो रहे हैं...',
        updateFailed: 'संस्थान विवरण अपडेट करने में विफल',
        placeholders: {
          collegeName: 'उदा. ABC इंजीनियरिंग कॉलेज',
          location: 'शहर या क्षेत्र',
          contactPerson: 'संपर्क व्यक्ति का नाम',
          email: 'ईमेल',
          phone: 'फोन नंबर',
          pathName: 'उदा. सॉफ्टवेयर डेवलपमेंट पथ',
          batchLabel: 'उदा. BT1',
          pathDuration: 'उदा. 4 वर्ष',
          description: 'संक्षेप में बताएं कि यह पथ क्या कवर करता है...'
        },
        toast: {
          enterCollegeName: 'कृपया कॉलेज का नाम दर्ज करें',
          collegeUpdated: 'कॉलेज सफलतापूर्वक अपडेट हो गया',
          pathNameRunwayRequired: 'पथ नाम और रनवे चयन आवश्यक हैं',
          pathUpdated: '{{runway}} सफलतापूर्वक अपडेट हुआ',
          pathCreated: 'नया {{runway}} बनाया गया',
          pathRemoved: 'पथ हटाया गया',
          downloadingCurriculum: '{{runway}} पाठ्यक्रम डाउनलोड हो रहा है...',
          pathLoadFailed: 'पथ लोड करने में विफल',
          pathSaveFailed: 'पथ सहेजने में विफल',
          pathDeleteFailed: 'पथ हटाने में विफल'
        }
      },
      batchManagement: {
        title: 'प्रोग्राम प्रबंधन',
        subtitle: 'रनवे ट्रैक और उनकी संबंधित बैचों का प्रबंधन करें',
        breadcrumb: 'प्रोग्राम',
        createNewBatch: 'नई बैच बनाएं',
        totalBatches: 'कुल बैच',
        activePrograms: 'सक्रिय प्रोग्राम',
        totalStudents: 'कुल छात्र',
        totalInstructors: 'कुल प्रशिक्षक',
        searchBatches: 'बैच खोजें...',
        runwayType: 'रनवे प्रकार',
        allRunways: 'सभी रनवे',
        startYear: 'प्रारंभ वर्ष',
        allYears: 'सभी वर्ष',
        status: 'स्थिति',
        allStatus: 'सभी स्थिति',
        inProgress: 'प्रगति में',
        completed: 'पूर्ण',
        totalBatchesLabel: 'कुल बैच',
        noBatchesFound: 'इस रनवे में कोई बैच नहीं मिली',
        batchName: 'बैच नाम',
        startPeriod: 'प्रारंभ अवधि',
        students: 'छात्र',
        instructors: 'प्रशिक्षक',
        duration: 'अवधि',
        progress: 'प्रगति',
        actions: 'क्रियाएं',
        enrolled: 'नामांकित',
        viewBatchStudents: 'बैच छात्र देखें',
        viewBatchInstructors: 'बैच प्रशिक्षक देखें',
        viewBatchStructure: 'बैच संरचना देखें',
        editBatchInfo: 'बैच जानकारी संपादित करें',
        deleteBatch: 'बैच हटाएं',
        editBatch: 'बैच संपादित करें',
        createNewBatchTitle: 'नई बैच बनाएं',
        modifyBatchDetails: 'बैच विवरण संशोधित करें और परिवर्तन सहेजें',
        addNewBatch: 'एक नई बैच जोड़ें। आप पूर्वनिर्धारित रनवे चुन सकते हैं या कस्टम रनवे बना सकते हैं',
        predefinedRunway: 'पूर्वनिर्धारित रनवे',
        customRunway: 'कस्टम रनवे',
        runwayName: 'रनवे नाम',
        runwayTrack: 'रनवे ट्रैक',
        selectRunwayTrack: 'रनवे ट्रैक चुनें',
        batchNamePlaceholder: 'उदा. बैच 001',
        startYearLabel: 'प्रारंभ वर्ष',
        startMonth: 'प्रारंभ महीना',
        studentsCount: 'छात्र संख्या',
        instructorsCount: 'प्रशिक्षक संख्या',
        cancel: 'रद्द करें',
        saveChanges: 'परिवर्तन सहेजें',
        createBatch: 'बैच बनाएं',
        saving: 'सहेजा जा रहा है...',
        creating: 'बनाया जा रहा है...',
        batchUpdated: 'बैच सफलतापूर्वक अपडेट हो गई!',
        batchCreated: 'बैच सफलतापूर्वक बनाई गई!',
        runwayNamePlaceholder: 'उदा. 6 महीने तीव्र',
        durationPlaceholder: 'उदा. 6 महीने',
        selectCourses: 'पाठ्यक्रम चुनें',
        viewCourses: 'पाठ्यक्रम देखें',
        viewProgress: 'प्रगति देखें',
        selectRunways: 'रनवे चुनें',
        selectedProgramCourses: 'चयनित प्रोग्राम पाठ्यक्रम'
      },
      instructorManagement: {
        title: 'प्रशिक्षक प्रबंधन',
        subtitle: 'प्रशिक्षकों, पाठ्यक्रमों और बैच आवंटन प्रबंधित करें',
        addInstructor: 'प्रशिक्षक जोड़ें',
        totalInstructors: 'कुल प्रशिक्षक',
        activeInstructors: 'सक्रिय प्रशिक्षक',
        coursesCovered: 'कवर किए गए पाठ्यक्रम',
        batchesCovered: 'कवर किए गए बैच',
        searchInstructor: 'प्रशिक्षक खोजें...',
        course: 'पाठ्यक्रम',
        allCourses: 'सभी पाठ्यक्रम',
        batch: 'बैच',
        allBatches: 'सभी बैच',
        regulation: 'नियम',
        allRegulations: 'सभी नियम',
        resetFilters: 'फ़िल्टर रीसेट करें',
        noInstructorsFound: 'कोई प्रशिक्षक नहीं मिले',
        tryAdjustingFilters: 'अपने फ़िल्टर समायोजित करने का प्रयास करें या नया प्रशिक्षक जोड़ें',
        instructor: 'प्रशिक्षक',
        subjects: 'विषय / विशेषज्ञान',
        status: 'स्थिति',
        actions: 'क्रियाएं',
        viewDetails: 'विवरण देखें',
        editInstructor: 'प्रशिक्षक संपादित करें',
        deleteInstructor: 'प्रशिक्षक हटाएं',
        instructorDetails: 'प्रशिक्षक विवरण',
        teachingInformation: 'शिक्षण जानकारी',
        activityInformation: 'गतिविधि जानकारी',
        totalStudents: 'कुल छात्र',
        joinDate: 'शामिल होने की तिथि',
        lastActive: 'अंतिम सक्रिय',
        deactivate: 'निष्क्रिय करें',
        editInstructorTitle: 'प्रशिक्षक संपादित करें',
        addNewInstructor: 'नया प्रशिक्षक जोड़ें',
        name: 'नाम',
        email: 'ईमेल',
        phone: 'फोन',
        subjectsLabel: 'विषय',
        active: 'सक्रिय',
        inactive: 'निष्क्रिय',
        cancel: 'रद्द करें',
        saveChanges: 'परिवर्तन सहेजें',
        addInstructorBtn: 'प्रशिक्षक जोड़ें',
        instructorNamePlaceholder: 'प्रशिक्षक का नाम दर्ज करें',
        emailAddressPlaceholder: 'ईमेल पता दर्ज करें',
        phoneNumberPlaceholder: 'फोन नंबर दर्ज करें',
        selectCourse: 'पाठ्यक्रम चुनें',
        selectBatch: 'बैच चुनें',
        selectRegulation: 'नियम चुनें',
        instructorUpdated: 'प्रशिक्षक सफलतापूर्वक अपडेट हो गया',
        instructorAdded: 'प्रशिक्षक सफलतापूर्वक जोड़ा गया',
        instructorDeleted: 'प्रशिक्षक सफलतापूर्वक हटा दिया गया',
        fillRequiredFields: 'कृपया सभी आवश्यक फ़ील्ड भरें',
        showing: 'दिखा रहा है',
        of: 'का',
        instructors: 'प्रशिक्षक',
        previous: 'पिछला',
        next: 'अगला'
      },
      studentManagement: {
        title: 'छात्र प्रबंधन',
        subtitle: 'छात्रों का प्रबंधन करें और पाठ्यक्रमों में उपस्थिति और प्रगति को ट्रैक करें',
        searchStudents: 'छात्र खोजें...',
        filters: 'फिल्टर',
        clearAll: 'सभी साफ करें',
        addStudent: 'छात्र जोड़ें',
        totalStudents: 'कुल छात्र',
        colleges: 'कॉलेज',
        avgAttendance: 'औसत उपस्थिति',
        avgProgress: 'औसत प्रगति',
        acrossAllStudents: 'सभी छात्रों में',
        courseCompletion: 'पाठ्यक्रम पूर्ति',
        studentsList: 'छात्र सूची',
        manageStudentsAndPerformance: 'अपने छात्रों और उनके प्रदर्शन का प्रबंधन करें',
        export: 'निर्यात करें',
        downloadExcel: 'Excel डाउनलोड करें',
        downloadPDF: 'PDF डाउनलोड करें',
        filtersLabel: 'फिल्टर:',
        filteredResult: 'फ़िल्टर किया गया परिणाम',
        students: 'छात्र',
        totalStudentsLabel: 'कुल छात्र',
        batch: 'बैच',
        allBatches: 'सभी बैच',
        runway: 'रनवे',
        allRunways: 'सभी रनवे',
        performance: 'प्रदर्शन',
        allPerformance: 'सभी प्रदर्शन',
        status: 'स्थिति',
        allStatus: 'सभी स्थिति',
        active: 'सक्रिय',
        inactive: 'निष्क्रिय',
        suspended: 'निलंबित',
        excellent: 'उत्कृष्ट',
        average: 'औसत',
        atRisk: 'जोखिम में',
        studentId: 'छात्र आईडी',
        name: 'नाम',
        batchName: 'बैच का नाम',
        branch: 'शाखा',
        startYear: 'प्रारंभ वर्ष',
        actions: 'क्रियाएं',
        viewProfile: 'प्रोफ़ाइल देखें',
        editStudent: 'छात्र संपादित करें',
        activateStudent: 'छात्र सक्रिय करें',
        suspendStudent: 'छात्र निलंबित करें',
        deleteStudent: 'छात्र हटाएं',
        attendance: 'उपस्थिति',
        target: 'लक्ष्य',
        completed: 'पूर्ण',
        testsPassed: 'परीक्षाएं उत्तीर्ण',
        testsAndStatus: 'परीक्षाएं और स्थिति',
        lastActive: 'अंतिम सक्रिय',
        year: 'वर्ष',
        progress: 'प्रगति',
        tests: 'परीक्षाएं',
        modules: 'मॉड्यूल',
        overview: 'अवलोकन',
        activity: 'गतिविधि',
        view: 'देखें',
        edit: 'संपादित करें',
        delete: 'हटाएं',
        showing: 'दिखा रहा है',
        of: 'का',
        deleteStudentTitle: 'छात्र हटाएं?',
        deleteStudentDescription: 'यह छात्र को सिस्टम से हटा देगा। नामांकन और प्रगति डेटा खो जाएगा।',
        cancel: 'रद्द करें',
        delete: 'हटाएं',
        studentUpdated: 'छात्र सफलतापूर्वक अपडेट हो गया',
        studentAdded: 'छात्र आईडी के साथ जोड़ा गया: {{id}}',
        studentActivated: 'छात्र सक्रिय कर दिया गया',
        studentSuspended: 'छात्र निलंबित कर दिया गया',
        studentProgressReset: 'छात्र प्रगति सफलतापूर्वक रीसेट हो गई',
        studentDeleted: 'छात्र हटा दिया गया',
        filtersCleared: 'फिल्टर साफ कर दिए गए',
        excelReportDownloaded: 'Excel रिपोर्ट डाउनलोड हो गई',
        pdfReportDownloaded: 'PDF रिपोर्ट डाउनलोड हो गई',
        lowRisk: 'कम जोखिम',
        mediumRisk: 'मध्यम जोखिम',
        highRisk: 'उच्च जोखिम',
        twoYear: '2 वर्ष',
        threeYear: '3 वर्ष',
        fourYear: '4 वर्ष',
        editStudentProfile: 'छात्र प्रोफ़ाइल संपादित करें',
        enrollNewStudent: 'नया छात्र नामांकित करें',
        modifyStudentCredentials: 'छात्र क्रेडेंशियल और शैक्षणिक रिकॉर्ड संपादित करें।',
        fillInformationToEnroll: 'सिस्टम में नया छात्र नामांकित करने के लिए नीचे जानकारी भरें।',
        studentName: 'छात्र का नाम',
        fullName: 'पूरा नाम',
        collegeBranch: 'कॉलेज / शाखा',
        selectCollege: 'कॉलेज चुनें',
        selectedCourse: 'चयनित पाठ्यक्रम',
        selectCourse: 'पाठ्यक्रम चुनें',
        academicYear: 'शैक्षणिक वर्ष',
        currentStatus: 'वर्तमान स्थिति',
        selectStatus: 'स्थिति चुनें',
        emailAddress: 'ईमेल पता',
        phoneNumber: 'फोन नंबर',
        attendance: 'उपस्थिति',
        assignments: 'असाइनमेंट',
        overallProgress: 'समग्र प्रगति',
        updateProfile: 'प्रोफ़ाइल अपडेट करें',
        pleaseEnterStudentName: 'कृपया छात्र का नाम दर्ज करें',
        pleaseSelectCollege: 'कृपया कॉलेज चुनें',
        pleaseSelectCourse: 'कृपया पाठ्यक्रम चुनें',
        studentProfile: 'छात्र प्रोफ़ाइल',
        completeAcademicPerformance: 'पूर्ण शैक्षणिक प्रदर्शन और प्रगति ट्रैकिंग',
        performanceSummary: 'प्रदर्शन सारांश',
        monthlyAttendanceBreakdown: 'मासिक उपस्थिति विवरण',
        assignmentStatus: 'असाइनमेंट स्थिति',
        testPerformance: 'परीक्षा प्रदर्शन',
        moduleProgress: 'मॉड्यूल प्रगति',
        recentActivity: 'हाल की गतिविधि',
        adminActions: 'व्यवस्थापक क्रियाएं',
        loginFrequency: 'लॉगिन आवृत्ति',
        lastActive: 'अंतिम सक्रिय',
        assignmentSubmissions: 'असाइनमेंट जमा करना',
        testAttempts: 'परीक्षण प्रयास',
        present: 'उपस्थित',
        absent: 'अनुपस्थित',
        sessions: 'सत्र',
        due: 'नियत तिथि',
        submitted: 'जमा किया गया',
        notSubmitted: 'जमा नहीं किया गया',
        score: 'अंक',
        date: 'तिथि',
        attempts: 'प्रयास',
        year: 'वर्ष',
        month: 'महीना',
        completed: 'पूर्ण',
        activate: 'सक्रिय करें',
        suspend: 'निलंबित करें',
        resetProgress: 'प्रगति रीसेट करें',
        noAttendanceData: 'कोई उपस्थिति डेटा उपलब्ध नहीं',
        noAssignmentData: 'कोई असाइनमेंट डेटा उपलब्ध नहीं',
        noTestData: 'कोई परीक्षा डेटा उपलब्ध नहीं',
        noModuleData: 'कोई मॉड्यूल डेटा उपलब्ध नहीं',
        noActivityData: 'कोई गतिविधि डेटा उपलब्ध नहीं'
      },
      scheduleManagement: {
        title: 'अनुसूची प्रबंधन',
        subtitle: 'शैक्षणिक ट्रैक',
        breadcrumb: 'अनुसूची केंद्र',
        addSchedule: 'अनुसूची जोड़ें',
        academicCalendar: 'शैक्षणिक कैलेंडर',
        searchSchedules: 'अनुसूची खोजें...',
        allRunways: 'सभी रनवे',
        allBatches: 'सभी बैच',
        selectRunwayFirst: 'पहले रनवे चुनें',
        allBatchesText: 'सभी बैच',
        list: 'सूची',
        calendar: 'कैलेंडर',
        noSchedulesFound: 'कोई अनुसूची नहीं मिली',
        tryAdjustingFilters: 'अपने खोज या फिल्टर समायोज करने का प्रयास करें, या एक नया अनुसूची बनाएं।',
        createFirstSchedule: 'पहला अनुसूची बनाएं',
        upcoming: 'आगामी',
        liveNow: 'अभी लाइव',
        completed: 'पूर्ण',
        editSession: 'सत्र संपादित करें',
        deleteTask: 'कार्य हटाएं',
        launch: 'लॉन्च करें',
        instructor: 'प्रशिक्षक',
        batch: 'बैच',
        mode: 'मोड',
        scheduleSession: 'अनुसूची सत्र',
        clickToEdit: 'संपादित करने के लिए क्लिक करें',
        clickToSeeAll: 'सभी देखने के लिए क्लिक करें',
        more: 'और',
        editSchedule: 'अनुसूची संपादित करें',
        addNewSchedule: 'नया अनुसूची जोड़ें',
        updateSchedule: 'अनुसूची अपडेट करें',
        newScheduleCreated: 'नया अनुसूची बनाया गया',
        scheduleUpdated: 'अनुसूची अपडेट हो गई',
        scheduleDeleted: 'अनुसूची हटा दी गई',
        areYouSureDelete: 'क्या आप इस अनुसूची को हटाना चाहते हैं?',
        pleaseFillRequiredFields: 'कृपया सभी आवश्यक फ़ील्ड भरें',
        runway: 'रनवे',
        batchLabel: 'बैच',
        date: 'तिथि',
        time: 'समय',
        sessionTitle: 'सत्र शीर्षक',
        description: 'विवरण',
        instructorLabel: 'प्रशिक्षक',
        roomLocation: 'कमरा/स्थान',
        meetingRoom: 'मिटिंग रूम',
        meetingLink: 'मिटिंग लिंक',
        online: 'ऑनलाइन',
        offline: 'ऑफलाइन',
        selectRunway: 'रनवे चुनें',
        selectBatch: 'बैच चुनें',
        selectInstructor: 'प्रशिक्षक चुनें',
        updateScheduleDetails: 'नीचे अनुसूची विवरण अपडेट करें',
        fillInformationToCreate: 'नया अनुसूची बनाने के लिए विवरण भरें',
        cancel: 'रद्द करें',
        createSchedule: 'अनुसूची बनाएं'
      },
      assessmentManagement: {
        assignment: 'आकलन',
        subtitle: 'बैचों में छात्र कार्यों का प्रबंधन और निगराण करें',
        createAssessment: 'आकलन बनाएं',
        totalActive: 'कुल सक्रिय',
        published: 'प्रकाशित',
        upcomingDeadlines: 'आगामी समय सीमा',
        totalSubmissions: 'कुल जमा किए गए कार्य',
        searchAssessment: 'आकलन शीर्षक खोजें...',
        runway: 'रनवे',
        batch: 'बैच',
        status: 'स्थिति',
        allRunways: 'सभी रनवे',
        allBatches: 'सभी बैच',
        allStatus: 'सभी स्थितियां',
        draft: 'मसौदा',
        closed: 'बंद',
        title: 'शीर्षक',
        instructor: 'प्रशिक्षक',
        deadline: 'समय सीमा',
        submissions: 'जमा किए गए कार्य',
        actions: 'क्रियाएं',
        viewDetails: 'विवरण देखें',
        editAssessment: 'आकलन संपादित करें',
        viewSubmissions: 'जमा किए गए कार्य देखें',
        delete: 'हटाएं',
        noAssessmentsMatch: 'आपके मानदंड से मेल खाते कोई आकलन नहीं मिले',
        showingAssessments: '{{count}} आकलन दिखा रहे हैं',
        previous: 'पिछला',
        next: 'अगला',
        backToAssessments: 'आकलन पर वापस जाएं',
        submissionOverview: 'जमा किए गए कार्य और छात्र प्रदर्शन',
        exportCSV: 'CSV निर्यात करें',
        contactPending: 'लंबित से संपर्क करें',
        avgEvaluationTAT: 'औसत मूल्यांकन समय',
        turnaroundTime: 'प्रतिक्रिया समय',
        submissionRate: 'जमा करने की दर',
        evaluationProgress: 'मूल्यांकन प्रगति',
        assignedInstructors: 'सौंपे गए प्रशिक्षक',
        active: 'सक्रिय',
        studentSubmissions: 'छात्र जमा किए गए कार्य',
        realTimeTracking: 'आकलन प्रगति का रियल-टाइम ट्रैकिंग',
        searchStudent: 'छात्र खोजें...',
        selectBatch: 'बैच चुनें',
        noStudentsFound: 'आपके फिल्टर से मेल खाते कोई छात्र नहीं मिले।',
        showingStudents: '{{current}} में से {{total}} छात्र दिखा रहे हैं',
        page: 'पृष्ठ {{current}} में से {{total}}',
        submissionContent: 'जमा किए गए कार्य सामग्री',
        repositoryURL: 'रिपॉजिटरी URL',
        liveDemo: 'लाइव डेमो',
        studentNotes: 'छात्र नोट्स',
        noAdditionalNotes: 'छात्र द्वारा कोई अतिरिक्त नोट्स प्रदान नहीं की गईं।',
        evaluationStatus: 'मूल्यांकन स्थिति',
        currentStatus: 'वर्तमान स्थिति',
        evaluated: 'मूल्यांकित',
        submitted: 'जमा किया गया',
        pending: 'लंबित',
        finalGrade: 'अंतिम ग्रेड',
        gradeAssessment: 'आकलन मूल्यांकित करें',
        student: 'छात्र',
        submission: 'जमा किया गया कार्य',
        reviewTAT: 'समीक्षण समय',
        marks: 'अंक',
        quickView: 'त्वरित दृश्य',
        evaluate: 'मूल्यांकित करें',
        viewSubmissionHistory: 'जमा किए गए कार्य इतिहास देखें',
        downloadAllFiles: 'सभी फाइलें डाउनलोड करें',
        resetSubmission: 'जमा किए गए कार्य रीसेट करें',
        noSubmission: 'कोई जमा किया गया कार्य नहीं'
      },
      assessmentForm: {
        backToAssessments: 'आकलन पर वापस जाएं',
        editAssessment: 'आकलन संपादित करें',
        createAssessment: 'आकलन बनाएं',
        updating: 'अपडेट कर रहे: {{id}}',
        designNewTask: 'छात्रों के लिए एक नया कार्य डिज़ाइन करें',
        saveDraft: 'मसौदा सहेजें',
        publish: 'प्रकाशित करें',
        basicInformation: 'बुनियादी जानकारी',
        assessmentTitle: 'आकलन शीर्षक',
        titlePlaceholder: 'उदा: प्रमाणीकरण API बनाएं',
        description: 'विवरण',
        descriptionPlaceholder: 'आकलन का संक्षिप्त अवलोकन...',
        descriptionHelp: 'इस कार्य से छात्र क्या सीखेगा इसका सारांश दें।',
        detailedInstructions: 'विस्तृत निर्देश',
        instructionsPlaceholder: 'छात्र के लिए चरण-दर-चरण निर्देश...',
        attachments: 'संलग्नक',
        uploadText: 'अपलोड करने के लिए क्लिक करें या खींचें और छोड़ें',
        uploadHelp: 'PDF, DOCX, ZIP (अधिकतम 10MB)',
        evaluationGrading: 'मूल्यांकन और ग्रेडिंग',
        maxMarks: 'अधिकतम अंक',
        passingMarks: 'उत्तीर्ण अंक',
        evaluationRubric: 'मूल्यांकन मानदंड',
        addCriteria: 'मानदंड जोड़ें',
        rubricPlaceholder: 'मूल्यांकन के लिए मानदंड परिभाषित करें (उदा: कोड गुणवत्ता, कार्यक्षमता...)',
        academicDetails: 'शैक्षणिक विवरण',
        runway: 'रनवे',
        selectRunway: 'रनवे चुनें',
        batchSubBatch: 'बैच / उप-बैच',
        selectBatch: 'बैच चुनें',
        deadline: 'समय सीमा',
        assignInstructor: 'प्रशिक्षक असाइन करें',
        selectInstructor: 'प्रशिक्षक चुनें',
        instructorHelp: 'असाइन किए गए प्रशिक्षक इस आकलन के लिए सभी छात्र जमा किए गए कार्यों का मूल्यांकन करने के लिए जिम्मेदार होंगे।',
        publicationStatus: 'प्रकाशन स्थिति',
        neverPublished: 'कभी प्रकाशित नहीं हुआ',
        newAssessment: 'नया आकलन',
        publishWarning: 'इस आकलन को प्रकाशित करने से चयनित बैचों के सभी छात्रों को तुरंत सूचित किया जाएगा।'
      },
      assignmentForm: {
        backToDashboard: 'डैशबोर्ड पर वापस जाएं',
        cancel: 'रद्द करें',
        saving: 'सहेज रहे हैं...',
        updateAssignment: 'असाइनमेंट अपडेट करें',
        createAssignment: 'असाइनमेंट बनाएं',
        editAssignment: 'असाइनमेंट संपादित करें',
        newAssignment: 'नया असाइनमेंट',
        draft: 'मसौदा',
        setupParameters: 'अपने असाइनमेंट पैरामीटर और मूल्यांकन मानदंड सेटअप करें।',
        generalInformation: 'सामान्य जानकारी',
        assignmentTitle: 'असाइनमेंट शीर्षक',
        titlePlaceholder: 'उदा: उन्नत React डिज़ाइन पैटर्न',
        category: 'श्रेणी',
        categoryPlaceholder: 'उदा: फ्रंटएंड विकास',
        assignmentType: 'असाइनमेंट प्रकार',
        selectType: 'प्रकार चुनें',
        standardSubmission: 'मानक जमा',
        codeRepository: 'कोड रिपॉजिटरी',
        interactiveQuiz: 'इंटरैक्टिव क्विज',
        description: 'विवरण',
        descriptionPlaceholder: 'छात्रों के लिए विस्तृत निर्देश प्रदान करें...',
        academicContext: 'शैक्षणिक संदर्भ',
        targetRunway: 'लक्ष्य रनवे',
        selectRunway: 'रनवे चुनें',
        targetBatch: 'लक्ष्य बैच',
        selectBatch: 'बैच चुनें',
        selectRunwayFirst: 'पहले रनवे चुनें',
        submissionEvaluation: 'जमा और मूल्यांकन',
        dueDateTime: 'नियत तिथि और समय',
        totalMarks: 'कुल अंक',
        scoringRubrics: 'मूल्यांकन मानदंड',
        addCriterion: 'मानदंड जोड़ें',
        rubricInfo: 'संरचित मूल्यांकन के लिए मानदंड सेटअप करें। मानदंड बिंदुओं का योग आदर्श रूप से कुल अंकों से मेल खाना चाहिए।',
        criterionPlaceholder: 'मानदंड {{index}} (उदा: कोड आर्किटेक्चर)',
        max: 'अधिकतम',
        totalRubricWeight: 'कुल मानदंड भार',
        saveChanges: 'परिवर्तन सहेजें',
        publishAssignment: 'असाइनमेंट प्रकाशित करें',
        assignmentNotFound: 'असाइनमेंट नहीं मिला',
        assignmentCreated: 'असाइनमेंट सफलतापूर्वक बनाया गया',
        assignmentUpdated: 'असाइनमेंट सफलतापूर्वक अपडेट किया गया'
      },
      questionManager: {
        contentManagement: 'सामग्री प्रबंधन',
        assignmentId: 'असाइनमेंट ID: {{id}}',
        addQuestion: 'प्रश्न जोड़ें',
        questions: 'प्रश्न',
        totalMarks: 'कुल अंक',
        estimatedTime: 'अनुमानित समय',
        options: 'विकल्प',
        tfOptions: 'सही/गलत विकल्प',
        programming: 'प्रोग्रामिंग',
        writeAnswer: 'उत्तर लिखें',
        keySet: 'की सेट',
        edit: 'संपादित करें',
        duplicate: 'डुप्लिकेट',
        delete: 'हटाएं',
        addQuestionToSet: 'सेट में प्रश्न जोड़ें'
      },
      distributionPage: {
        manageDistribution: 'वितरण प्रबंधन',
        assignmentId: 'असाइनमेंट ID: {{id}}',
        applySyncDistribution: 'वितरण लागू और सिंक करें',
        targetRunways: '1. लक्ष्य रनवे',
        targetBatches: '2. लक्ष्य बैच',
        selectAll: 'सभी चुनें',
        filterBatches: 'बैच फ़िल्टर करें...',
        students: 'छात्र',
        viewStudents: 'छात्र देखें',
        availabilityControls: '3. उपलब्धता नियंत्रण',
        startDateTime: 'प्रारंभ दिनांक और समय',
        endDateTime: 'समाप्ति दिनांक और समय',
        keepOpen: 'खुला रखें (कोई समयसीमा नहीं)',
        liveStatus: 'लाइव स्थिति',
        eligibilityEngine: 'पात्रता इंजन',
        studentsWillReceive: 'छात्रों को तुरंत पहुंच मिलेगी।',
        runways: 'रनवे',
        batches: 'बैच',
        conflictCheck: 'संघर्ष जांच',
        clean: 'साफ',
        selected: 'चयनित',
        confirmDistribution: 'वितरण की पुष्टि करें'
      },
      attendance: {
        markAttendance: 'उपस्थिति चिह्नित करें',
        efficiencyMarking: 'बड़े रनवे बैचों के लिए कुशल चिह्नित उपकरण।',
        attendanceHistory: 'उपस्थिति इतिहास',
        report: 'रिपोर्ट',
        runway: 'रनवे',
        year: 'वर्ष',
        batch: 'बैच',
        date: 'दिनांक',
        searchByNameBatch: 'नाम या बैच से खोजें...',
        studentList: 'छात्र सूची',
        markAllPresent: 'सभी को उपस्थित चिह्नित करें',
        markAllAbsent: 'सभी को अनुपस्थित चिह्नित करें',
        markAll: 'सभी को {{status}} के रूप में चिह्नित किया गया',
        attendanceReset: 'उपस्थिति रीसेट की गई',
        attendanceSummary: 'उपस्थिति सारांश',
        attendanceRate: 'उपस्थिति दर',
        total: 'कुल',
        present: 'उपस्थित',
        absent: 'अनुपस्थित',
        marked: 'चिह्नित: {{count}}',
        remaining: 'शेष: {{count}}',
        saveAsDraft: 'ड्राफ्ट के रूप में सहेजें',
        saveAttendance: 'उपस्थिति सहेजें',
        attendanceRecorded: 'उपस्थिति सफलतापूर्वक रिकॉर्ड हो गई!',
        markAllStudents: 'कृपया सभी {{count}} छात्रों की उपस्थिति चिह्नित करें।',
        noStudentsFound: 'इस बैच के लिए कोई छात्र नहीं मिला।',
        markedOfTotal: '{{total}} में से {{marked}} छात्र चिह्नित किए गए',
        presentStatus: 'उपस्थित',
        absentStatus: 'अनुपस्थित'
      },
      attendanceHistory: {
        attendanceHistory: 'उपस्थिति इतिहास',
        backToMarking: 'चिह्नित करने पर वापस जाएं',
        goBack: 'वापस जाएं',
        allYears: 'सभी वर्ष',
        customRange: 'कस्टम रेंज',
        viewYearly: 'वार्षिक देखें',
        exportData: 'डेटा निर्यात करें',
        searchHistory: 'इतिहास खोजें...',
        allBatches: 'सभी बैच',
        yearlyAttendance: 'वार्षिक उपस्थिति',
        monthsInYear: '{{year}} में महीने',
        dailySessions: 'दैनिक सत्र',
        customRangeSearch: 'कस्टम रेंज खोज',
        records: 'रिकॉर्ड',
        title: 'शीर्षक',
        sessions: 'सत्र',
        avgTotalPresent: 'औसत/कुल उपस्थित',
        avgTotalAbsent: 'औसत/कुल अनुपस्थित',
        status: 'स्थिति',
        view: 'देखें',
        fullAcademicYear: 'पूर्ण शैक्षणिक वर्ष {{year}}',
        monthlyConsolidated: 'मासिक संकलित',
        recordedOn: '{{date}} को रिकॉर्ड किया गया',
        days: 'दिन',
        noHistoryFound: 'कोई इतिहास नहीं मिला',
        expandSearch: 'अपनी खोज का विस्तार करें या दूसरी अवधि जांचें।',
        customRangeLabel: 'कस्टम रेंज'
      },
      adminPanel: {
        adminPanel: 'एडमिन पैनल',
        comprehensiveManagement: 'व्यापक प्लेटफॉर्म प्रबंधन',
        overview: 'अवलोकन',
        users: 'उपयोगकर्ता',
        courses: 'पाठ्यक्रम',
        jobs: 'नौकरियां',
        analytics: 'विश्लेषण',
        logs: 'गतिविधि लॉग',
        settings: 'सेटिंग्स',
        totalUsers: 'कुल उपयोगकर्ता',
        totalCourses: 'कुल पाठ्यक्रम',
        activeJobs: 'सक्रिय नौकरियां',
        revenue: 'राजस्व',
        inLast7Days: '+{{count}} पिछले 7 दिनों में',
        published: '{{count}} प्रकाशित',
        applications: '{{count}} आवेदन',
        fromLastMonth: '+{{count}}% पिछले महीने से',
        userDistributionByRole: 'भूमिका के अनुसार उपयोगकर्ता वितरण',
        students: 'छात्र',
        instructors: 'प्रशिक्षक',
        admins: 'एडमिन',
        quickActions: 'त्वरित कार्य',
        manageUsers: 'उपयोगकर्ता प्रबंधित करें',
        manageCourses: 'पाठ्यक्रम प्रबंधित करें',
        manageJobs: 'नौकरियां प्रबंधित करें',
        failedToFetchDashboard: 'डैशबोर्ड डेटा लाने में विफल'
      },
      superAdminInstitutes: {
        instituteManagement: 'संस्थान प्रबंधन',
        manageAllInstitutes: 'सभी संस्थान प्रबंधित करें',
        createInstitute: 'संस्थान बनाएं',
        total: 'कुल',
        active: 'सक्रिय',
        pending: 'लंबित',
        suspended: 'निलंबित',
        allInstitutes: 'सभी संस्थान',
        plans: 'योजनाएं',
        search: 'खोजें...',
        allStatus: 'सभी स्थिति',
        loading: 'लोड हो रहा है...',
        noInstitutes: 'कोई संस्थान नहीं',
        noPendingRequests: 'कोई लंबित अनुरोध नहीं',
        view: 'देखें',
        activate: 'सक्रिय करें',
        suspend: 'निलंबित करें',
        delete: 'हटाएं',
        approve: 'स्वीकृत करें',
        reject: 'अस्वीकार करें',
        create: 'बनाएं',
        cancel: 'रद्द करें',
        unlimited: 'असीमित',
        students: 'छात्र',
        courses: 'पाठ्यक्रम',
        storage: 'भंडारण',
        slug: 'स्लग',
        email: 'ईमेल',
        description: 'विवरण',
        city: 'शहर',
        country: 'देश',
        name: 'नाम',
        status: 'स्थिति',
        users: 'उपयोगकर्ता',
        approveRequest: 'अनुरोध स्वीकृत करें?',
        rejectRequest: 'अनुरोध अस्वीकार करें?',
        reason: 'कारण...',
        instituteCreated: 'संस्थान बनाया गया',
        activated: 'सक्रिय किया गया',
        suspended: 'निलंबित किया गया',
        deleted: 'हटाया गया',
        approved: 'स्वीकृत!',
        rejected: 'अस्वीकार किया गया',
        failedToLoadData: 'डेटा लोड करने में विफल',
        failed: 'विफल',
        deleteConfirm: 'हटाएं?',
        failedToLoadDetails: 'विवरण लोड करने में विफल'
      },
      userManagement: {
        userManagement: 'उपयोगकर्ता प्रबंधन',
        managePlatformUsers: 'प्लेटफॉर्म उपयोगकर्ताओं और भूमिकाओं का प्रबंधन करें',
        addUser: 'उपयोगकर्ता जोड़ें',
        searchUsers: 'ईमेल या नाम से उपयोगकर्ता खोजें...',
        id: 'आईडी',
        email: 'ईमेल',
        name: 'नाम',
        role: 'भूमिका',
        joined: 'शामिल हुए',
        student: 'छात्र',
        instructor: 'प्रशिक्षक',
        admin: 'एडमिन',
        editUser: 'उपयोगकर्ता संपादित करें',
        createNewUser: 'नया उपयोगकर्ता बनाएं',
        updateUser: 'उपयोगकर्ता जानकारी अपडेट करें',
        addNewUser: 'प्लेटफॉर्म पर नया उपयोगकर्ता जोड़ें',
        fullName: 'पूरा नाम',
        password: 'पासवर्ड',
        leaveEmptyToKeepCurrent: '(वर्तमान रखने के लिए खाली छोड़ें)',
        deleteUser: 'उपयोगकर्ता हटाएं',
        userDeletedSuccessfully: 'उपयोगकर्ता सफलतापूर्वक हटाया गया',
        userCreatedSuccessfully: 'उपयोगकर्ता सफलतापूर्वक बनाया गया',
        userUpdatedSuccessfully: 'उपयोगकर्ता सफलतापूर्वक अपडेट किया गया',
        roleUpdatedSuccessfully: 'भूमिका सफलतापूर्वक अपडेट की गई',
        failedToFetchUsers: 'उपयोगकर्ताओं को लाने में विफल',
        failedToDeleteUser: 'उपयोगकर्ता को हटाने में विफल',
        failedToUpdateRole: 'भूमिका अपडेट करने में विफल',
        operationFailed: 'ऑपरेशन विफल',
        deleteUserConfirm: 'उपयोगकर्ता {{email}} हटाएं?',
        update: 'अपडेट',
        create: 'बनाएं',
        cancel: 'रद्द करें'
      },
      jobManagement: {
        jobManagement: 'नौकरी प्रबंधन',
        manageJobs: 'नौकरी पोस्टिंग और आवेदनों का प्रबंधन करें',
        addJob: 'नौकरी जोड़ें',
        searchJobs: 'नौकरियां खोजें...',
        id: 'आईडी',
        jobTitle: 'नौकरी शीर्षक',
        location: 'स्थान',
        type: 'प्रकार',
        salary: 'वेतन',
        remote: 'रिमोट',
        notSpecified: 'निर्दिष्ट नहीं',
        editJob: 'नौकरी संपादित करें',
        createNewJob: 'नई नौकरी बनाएं',
        updateJob: 'नौकरी पोस्टिंग अपडेट करें',
        addNewJob: 'नई नौकरी पोस्टिंग जोड़ें',
        company: 'कंपनी',
        jobType: 'नौकरी प्रकार',
        fullTime: 'पूर्णकालिक',
        partTime: 'अंशकालिक',
        contract: 'अनुबंध',
        internship: 'इंटर्नशिप',
        salaryRange: 'वेतन रेंज',
        description: 'विवरण',
        requirements: 'आवश्यकताएं',
        listRequirements: 'आवश्यकताएं सूचीबद्ध करें (प्रति लाइन एक)',
        deleteJob: 'नौकरी हटाएं',
        jobDeletedSuccessfully: 'नौकरी सफलतापूर्वक हटाई गई',
        jobCreatedSuccessfully: 'नौकरी सफलतापूर्वक बनाई गई',
        jobUpdatedSuccessfully: 'नौकरी सफलतापूर्वक अपडेट की गई',
        failedToFetchJobs: 'नौकरियां लाने में विफल',
        failedToDeleteJob: 'नौकरी हटाने में विफल',
        operationFailed: 'ऑपरेशन विफल',
        deleteJobConfirm: 'नौकरी "{{title}}" हटाएं?',
        update: 'अपडेट',
        create: 'बनाएं',
        cancel: 'रद्द करें'
      },
      analyticsDashboard: {
        analyticsDashboard: 'एनालिटिक्स डैशबोर्ड',
        platformPerformance: 'प्लेटफॉर्म प्रदर्शन और इनसाइट्स',
        revenue: 'राजस्व',
        users: 'उपयोगकर्ता',
        courses: 'कोर्स',
        engagement: 'जुड़ाव',
        revenueOverview: 'राजस्व अवलोकन',
        last7Days: 'पिछले 7 दिन',
        last30Days: 'पिछले 30 दिन',
        lastQuarter: 'पिछली तिमाही',
        lastYear: 'पिछला वर्ष',
        totalRevenue: 'कुल राजस्व',
        transactions: 'लेनदेन',
        avgTransaction: 'औसत लेनदेन',
        perTransaction: 'प्रति लेनदेन',
        acrossAllPaymentMethods: 'सभी भुगतान विधियों में',
        fromLastPeriod: '+{{count}}% पिछली अवधि से',
        revenueTrend: 'राजस्व ट्रेंड',
        chartVisualization: 'चार्ट विज़ुअलाइज़ेशन यहां होगा (Chart.js या Recharts एकीकृत करें)',
        userAnalytics: 'उपयोगकर्ता एनालिटिक्स',
        userGrowth: 'उपयोगकर्ता वृद्धि',
        userActivity: 'उपयोगकर्ता गतिविधि',
        userGrowthChart: 'उपयोगकर्ता वृद्धि चार्ट यहां होगा',
        activityHeatmap: 'गतिविधि हीटमैप यहां होगा',
        courseAnalytics: 'कोर्स एनालिटिक्स',
        mostPopularCourses: 'सबसे लोकप्रिय कोर्स',
        coursePopularityChart: 'कोर्स लोकप्रियता चार्ट यहां होगा',
        platformEngagement: 'प्लेटफॉर्म जुड़ाव',
        dailyActiveUsers: 'दैनिक सक्रिय उपयोगकर्ता',
        sessionDuration: 'सत्र अवधि',
        dauChart: 'DAU चार्ट यहां होगा',
        sessionDurationChart: 'सत्र अवधि चार्ट यहां होगा',
        failedToFetchRevenueData: 'राजस्व डेटा लाने में विफल'
      },
      activityLogs: {
        activityLogs: 'गतिविधि लॉग',
        trackSystemActivities: 'सिस्टम गतिविधियों और परिवर्तनों को ट्रैक करें',
        noActivityLogsFound: 'कोई गतिविधि लॉग नहीं मिला',
        create: 'बनाएं',
        update: 'अपडेट',
        delete: 'हटाएं',
        user: 'उपयोगकर्ता',
        failedToFetchActivityLogs: 'गतिविधि लॉग लाने में विफल'
      },
      systemSettings: {
        systemSettings: 'सिस्टम सेटिंग्स',
        configurePlatform: 'प्लेटफॉर्म-व्यापी सेटिंग्स कॉन्फ़िगर करें',
        saveChanges: 'परिवर्तन सहेजें',
        saving: 'सहेज रहे हैं...',
        general: 'सामान्य',
        security: 'सुरक्षा',
        email: 'ईमेल',
        advanced: 'उन्नत',
        siteName: 'साइट नाम',
        siteDescription: 'साइट विवरण',
        supportEmail: 'समर्थन ईमेल',
        maxUploadSize: 'अधिकतम अपलोड आकार (MB)',
        enableUserRegistrations: 'उपयोगकर्ता पंजीकरण सक्षम करें',
        allowNewUsersToRegister: 'प्लेटफॉर्म पर नए उपयोगकर्ताओं को पंजीकृत करने की अनुमति दें',
        requireEmailVerification: 'ईमेल सत्यापन आवश्यक करें',
        usersMustVerifyEmail: 'उपयोगकर्ताओं को प्लेटफॉर्म तक पहुंचने से पहले अपना ईमेल सत्यापित करना होगा',
        enableTwoFactor: 'दो-कारक प्रमाणीकरण सक्षम करें',
        allowUsersToEnable2FA: 'उपयोगकर्ताओं को अपने खातों के लिए 2FA सक्षम करने की अनुमति दें',
        sessionTimeout: 'सत्र टाइमआउट (मिनटों में)',
        emailSettingsConfigured: 'ईमेल सेटिंग्स पर्यावरण चर के माध्यम से कॉन्फ़िगर किए गए हैं (SMTP सर्वर, क्रेडेंशियल्स, आदि)',
        requiredEnvironmentVariables: 'आवश्यक पर्यावरण चर:',
        maintenanceMode: 'रखरखाव मोड',
        maintenanceWarning: '⚠️ यह प्लेटफॉर्म को एडमिन को छोड़कर सभी उपयोगकर्ताओं के लिए अप्रवेशनीय बना देगा',
        databaseBackup: 'डेटाबेस बैकअप',
        downloadDatabaseBackup: 'डेटाबेस बैकअप डाउनलोड करें',
        clearCache: 'कैश साफ करें',
        clearSystemCache: 'सिस्टम कैश साफ करें',
        settingsSavedSuccessfully: 'सेटिंग्स सफलतापूर्वक सहेजी गई',
        failedToFetchSettings: 'सिस्टम सेटिंग्स लाने में विफल',
        failedToSaveSettings: 'सेटिंग्स सहेजने में विफल'
      },
      profile: {
        profile: 'प्रोफ़ाइल',
        memberSince: '{{year}} से सदस्य',
        totalPoints: 'कुल अंक',
        currentStreak: 'वर्तमान स्ट्रीक',
        globalRank: 'वैश्विक रैंक',
        enrolledCourses: 'नामांकित पाठ्यक्रम',
        keepLearning: 'सीखते रहें!',
        dontBreakIt: 'इसे तोड़ें नहीं!',
        topPerformer: 'शीर्ष प्रदर्शक!',
        activeLearning: 'सक्रिय शिक्षा',
        achievements: 'उपलब्धियां',
        firstCourse: 'पहला पाठ्यक्रम',
        enrolledInFirstCourse: 'अपने पहले पाठ्यक्रम में नामांकित हुए',
        weekWarrior: 'सप्ताह योद्धा',
        sevenDayStreak: '7-दिवसीय शिक्षा स्ट्रीक',
        courseCompleter: 'पाठ्यक्रम पूर्णकर्ता',
        completeFirstCourse: 'पहला पाठ्यक्रम पूरा करें',
        failedToFetchStats: 'आँकड़े लाने में विफल'
      },
      settings: {
        settings: 'सेटिंग्स',
        managePreferences: 'अपनी प्राथमिकताएं प्रबंधित करें',
        appearance: 'दिखावट',
        customizeAppLook: 'ऐप कैसा दिखता है इसे अनुकूलित करें',
        darkMode: 'डार्क मोड',
        enableDarkTheme: 'डार्क थीम सक्षम करें',
        language: 'भाषा',
        choosePreferredLanguage: 'अपनी पसंदीदा भाषा चुनें',
        notifications: 'सूचनाएं',
        manageNotificationPreferences: 'सूचना प्राथमिकताएं प्रबंधित करें',
        emailNotifications: 'ईमेल सूचनाएं',
        pushNotifications: 'पुश सूचनाएं',
        courseUpdates: 'पाठ्यक्रम अपडेट'
      },
      sidebar: {
        courseManagement: 'पाठ्यक्रम प्रबंधन',
        batchManagement: 'कार्यक्रम प्रबंधन',
        instructorManagement: 'प्रशिक्षक प्रबंधन',
        studentManagement: 'छात्र प्रबंधन',
        scheduleManagement: 'समय सारिणी प्रबंधन',
        assessments: 'मूल्यांकन',
        assignmentManagement: 'असाइनमेंट प्रबंधन',
        markAttendance: 'उपस्थिति अंकित करें',
        attendanceHistory: 'उपस्थिति इतिहास',
        institutes: 'संस्थान',
        instituteAnalytics: 'संस्थान एनालिटिक्स',
        branding: 'ब्रांडिंग',
        instructorDashboard: 'प्रशिक्षक डैशबोर्ड',
        batchSchedule: 'बैच समय सारिणी',
        assessmentsManagement: 'मूल्यांकन प्रबंधन',
        managePanel: 'प्रबंधन पैनल',
        liveClasses: 'लाइव क्लासेस',
        testsQuiz: 'टेस्ट/क्विज',
        assignments: 'असाइनमेंट',
        bookmarks: 'बुकमार्क',
        codeLab: 'कोड लैब',
        darkMode: 'डार्क मोड',
        lightMode: 'लाइट मोड',
        logout: 'लॉगआउट',
        superAdmin: 'सुपर एडमिन',
        payments: 'भुगतानें',
        paymentHistory: 'भुगतान इतिहास',
        paymentManagement: 'भुगतान प्रबंधन',
        studentPaymentSupport: 'छात्र भुगतान समर्थन'
      },
      assignmentManagement: {
        title: 'असाइनमेंट पोर्टल',
        subtitle: 'वैश्विक छात्र आकलन बनाएं, वितरित करें और प्रबंधित करें।',
        control: 'असाइनमेंट नियंत्रण',
        createAssignment: 'असाइनमेंट बनाएं',
        totalAssignments: 'कुल असाइनमेंट',
        reachingStudents: 'छात्र पहुंच',
        liveSubmissions: 'लाइव जमा किए गए कार्य',
        pendingReviews: 'लंबित समीक्षा',
        searchAssignments: 'असाइनमेंट खोजें...',
        allSubjects: 'सभी विषय',
        allRunways: 'सभी रनवे',
        programming: 'प्रोग्रामिंग',
        aptitude: 'योग्यता',
        mathematics: 'गणित',
        assignmentDetails: 'असाइनमेंट विवरण',
        distribution: 'वितरण',
        marksTime: 'अंक/समय',
        status: 'स्थिति',
        actions: 'क्रियाएं',
        batches: 'बैच',
        marks: 'अंक',
        mins: 'मिनट',
        live: 'लाइव',
        draft: 'मसौदा',
        questions: 'प्रश्न',
        view: 'देखें',
        edit: 'संपादित करें',
        delete: 'हटाएं',
        createNewAssignment: 'नया असाइनमेंट बनाएं',
        step1BasicInfo: 'चरण 1: बुनियादी जानकारी',
        cancel: 'रद्द करें',
        saveContinue: 'सहेजें और जारी रखें',
        assignmentTitle: 'असाइनमेंट शीर्षक',
        titlePlaceholder: 'उदा: उन्नत React पैटर्न में महारत हासिल करें',
        subject: 'विषय',
        targetLevel: 'लक्ष्य स्तर',
        totalMarks: 'कुल अंक',
        difficulty: 'कठिनाई',
        beginner: 'शुरुआती',
        intermediate: 'मध्यम',
        advanced: 'उन्नत',
        assignmentDescription: 'असाइनमेंट विवरण',
        descriptionPlaceholder: 'इस असाइनमेंट के उद्देश्यों और आवश्यकताओं की व्याख्या करें...',
        tagsKeywords: 'टैग और कीवर्ड',
        separateByCommas: 'अल्पविराम से अलग करें',
        tagsPlaceholder: 'react, frontend, hooks, level-3',
        whatHappensNext: 'अगला क्या होता है?',
        nextStepInfo: 'इस जानकारी को सहेजने के बाद, आपको **प्रश्न प्रबंधक** पर निर्देशित किया जाएगा जहां आप इस असाइनमेंट में प्रश्न जोड़ना शुरू कर सकते हैं।'
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
